
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fZYO5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");

/**
 * @generated SignedSource<<2747910bdd49eae92d83e5efc4f29e24>>
 * @relayHash 561689ed4102f69a1d3aeb07b824e265
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b78b66a4dd4122f3ad0f6ed6bee86a5a71604683f52a0b53a44b11b7801c73c
const $c748160807ae1faa$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = [
        {
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "location",
                    "value": "system.space.tools"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceSettingsNavigationV1SpaceSettingsNavigationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceSettingsNavigationV1SpaceSettingsNavigationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "561689ed4102f69a1d3aeb07b824e265",
            "id": "7b78b66a4dd4122f3ad0f6ed6bee86a5a71604683f52a0b53a44b11b7801c73c",
            "metadata": {},
            "name": "SpaceSettingsNavigationV1SpaceSettingsNavigationQuery",
            "operationKind": "query",
            "text": "query SpaceSettingsNavigationV1SpaceSettingsNavigationQuery($spaceKey:String){webItemSections(location:\"system.space.tools\",key:$spaceKey){id,label,cacheKey,items{id,completeKey,label,url,icon{path}}},space(key:$spaceKey){alias,id,key,currentUser{isAdmin}}}"
        }
    };
}();
$c748160807ae1faa$var$node.hash = "c624a190ca81d29c786ad57083ceac91";
var $c748160807ae1faa$export$2e2bcd8739ae039 = $c748160807ae1faa$var$node;






var $gMc0m = parcelRequire("gMc0m");


var $jSnXV = parcelRequire("jSnXV");


var $gdv5Z = parcelRequire("gdv5Z");


var $4A7Gn = parcelRequire("4A7Gn");


var $0DTaW = parcelRequire("0DTaW");


var $4JDbp = parcelRequire("4JDbp");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $7zgzO = parcelRequire("7zgzO");

/* SpacePermissionSharedHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $jmjWc = parcelRequire("jmjWc");


const $44f6f4cb582c4e2d$export$39c9f7c3d7856e7a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Ldgqp",
    name: "CopySpacePermissionsAndDefaultPermissionsLoader",
    loader: async ()=>(await (parcelRequire("amKzv"))).CopySpacePermissionsAndDefaultPermissions
});






var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $iXCQx = parcelRequire("iXCQx");


var $eyWa4 = parcelRequire("eyWa4");


var $aoVih = parcelRequire("aoVih");


var $iHPbg = parcelRequire("iHPbg");


var $1DHa6 = parcelRequire("1DHa6");


var $8o1lj = parcelRequire("8o1lj");


var $9ot3w = parcelRequire("9ot3w");


var $d8eRd = parcelRequire("d8eRd");


var $6xdDU = parcelRequire("6xdDU");


var $lsxnT = parcelRequire("lsxnT");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $5ZqQS = parcelRequire("5ZqQS");





var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $aBfpe = parcelRequire("aBfpe");


var $dK51B = parcelRequire("dK51B");




const $878f415eaa51ca50$export$4d4523093bac6758 = ({ variables: variables })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/api/space?spaceKey=${variables.spaceKey}&expand=permissions`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: (payload, _variables)=>{
            const unlicensedAccessPerm = (payload.results?.[0]?.permissions || []).find((perm)=>perm.unlicensedAccess && perm.operation?.operation === 'read' && perm.operation?.targetType === 'space');
            return {
                experimentalUnlicensedPermission: {
                    unlicensedPermissionId: unlicensedAccessPerm?.id ?? null
                }
            };
        },
        parseResponseOnError: ()=>{
            return {
                results: []
            };
        },
        variables: variables
    });
};






var $9o40q = parcelRequire("9o40q");

const $4a2d8345ddd70906$export$de719b13f195ad88 = ({ update: update })=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: (variables)=>`/wiki/rest/api/space/${variables.spaceKey}/permission/${variables.permissionId}`,
        method: 'DELETE',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: (response)=>({
                success: response.status === 204
            }),
        parseResult: (json)=>({
                experimentalRemoveUnlicensedPermission: {
                    success: json.success
                }
            }),
        update: update
    });
};


const $4382bc282ddc8e8a$var$i18n = (0, $aXWIB.defineMessages)({
    infoBoxTitle: {
        id: "space-permissions.jsm-prompt.info-box-title",
        defaultMessage: "Any active user can view this space"
    },
    infoBoxDescription: {
        id: "space-permissions.jsm-prompt.info-box-description",
        defaultMessage: "Any active user can view content in this space, including users who don\u2019t have a Confluence license. This was enabled through Jira Service Management so people can view knowledge articles when raising a help request."
    },
    infoBoxButtonLink: {
        id: "space-permissions.jsm-prompt.info-box-button",
        defaultMessage: "Disable this permission"
    },
    modalTitle: {
        id: "space-permissions.jsm-prompt.modal-title",
        defaultMessage: "Disable this permission for all active users"
    },
    modalIntroParagraph: {
        id: "space-permissions.jsm-prompt.modal-intro-paragraph",
        defaultMessage: "This space is linked to a project in Jira Service Management so users can view knowledge articles when they raise requests."
    },
    modalActionParagraph: {
        id: "space-permissions.jsm-prompt.modal-action-paragraph",
        defaultMessage: "If you disable this permission, it can only be enabled again through Jira Service Management."
    },
    modalPrimaryAction: {
        id: "space-permissions.jsm-prompt.modal-primary-action",
        defaultMessage: "Disable"
    },
    modalCancelAction: {
        id: "space-permissions.jsm-prompt.modal-cancel-action",
        defaultMessage: "Cancel"
    },
    modalIntroParagraphGalaxia: {
        id: "space-permissions.jsm-prompt.modal-intro-paragraph-galaxia",
        defaultMessage: "This space is linked to a Jira Service Management space so users can view knowledge articles when they raise requests."
    }
});
const $4382bc282ddc8e8a$export$772f74ec82ccc66a = ({ spaceKey: spaceKey })=>{
    const [isOpen, setOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    const { data: data, error: error } = (0, $878f415eaa51ca50$export$4d4523093bac6758)({
        variables: {
            spaceKey: spaceKey
        }
    });
    const removeUnlicensedPermissionMutationOptions = {
        update (_) {
            // For experimental mutation, update the useExperimentalQuery cache
            // The cache key matches the URL and variables from the query
            const cacheKey = (0, $6l6jb.generateCacheKey)({
                url: `/wiki/rest/api/space?spaceKey=${spaceKey}&expand=permissions`,
                method: 'GET',
                headers: {
                    'Content-Type': (0, $aBfpe.MediaType).JSON
                },
                variables: {
                    spaceKey: spaceKey
                }
            });
            setQueryState(cacheKey, {
                data: {
                    experimentalUnlicensedPermission: {
                        unlicensedPermissionId: null
                    }
                },
                loading: false,
                error: undefined,
                called: true
            });
        }
    };
    const [removeUnlicensedPermission] = (0, $4a2d8345ddd70906$export$de719b13f195ad88)(removeUnlicensedPermissionMutationOptions);
    if (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        });
        //Fail View Experience
        experienceTracker.fail({
            name: (0, $irVI7.VIEW_JSM_BANNER),
            error: error
        });
    }
    const onEditPermsClicked = ()=>{
        setOpen(true);
        //Start Disable JSM Experience
        experienceTracker.start({
            name: (0, $irVI7.DISABLE_JSM_PERMISSIONS)
        });
    };
    const closeModal = ()=>{
        setOpen(false);
    };
    const onDisableClicked = async ()=>{
        try {
            await removeUnlicensedPermission({
                variables: {
                    spaceKey: spaceKey,
                    permissionId: data?.experimentalUnlicensedPermission?.unlicensedPermissionId || 0
                },
                ...removeUnlicensedPermissionMutationOptions
            });
        } catch (error) {
            //Fail Disable JSM Experience
            experienceTracker.fail({
                name: (0, $irVI7.DISABLE_JSM_PERMISSIONS),
                error: error
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        } finally{
            // await updateUnlicensedPermission();
            setOpen(false);
        }
        //Succeed Disable JSM Experience
        experienceTracker.succeed({
            name: (0, $irVI7.DISABLE_JSM_PERMISSIONS)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, data?.experimentalUnlicensedPermission?.unlicensedPermissionId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.VIEW_JSM_BANNER)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        title: formatMessage($4382bc282ddc8e8a$var$i18n.infoBoxTitle),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iHPbg.default), {
                href: "#",
                key: "disable-btn",
                onClick: onEditPermsClicked
            }, formatMessage($4382bc282ddc8e8a$var$i18n.infoBoxButtonLink))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, formatMessage($4382bc282ddc8e8a$var$i18n.infoBoxDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_JSM_BANNER)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: closeModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, formatMessage($4382bc282ddc8e8a$var$i18n.modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? $4382bc282ddc8e8a$var$i18n.modalIntroParagraphGalaxia : $4382bc282ddc8e8a$var$i18n.modalIntroParagraph)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, formatMessage($4382bc282ddc8e8a$var$i18n.modalActionParagraph)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: onDisableClicked
    }, formatMessage($4382bc282ddc8e8a$var$i18n.modalPrimaryAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: closeModal
    }, formatMessage($4382bc282ddc8e8a$var$i18n.modalCancelAction)))))) : null);
};


const $ee4e36fb9d07b3a4$var$CopySpaceContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt412x7",
            __cmplp.className
        ])
    });
});
const $ee4e36fb9d07b3a4$export$6b7c6156afa05617 = ({ spaceKey: spaceKey })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isFreeTenant = edition === (0, $euL71.ConfluenceEdition).FREE;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isFreeTenant ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4382bc282ddc8e8a$export$772f74ec82ccc66a), {
        spaceKey: spaceKey
    }), isFreeTenant ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ee4e36fb9d07b3a4$var$CopySpaceContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44f6f4cb582c4e2d$export$39c9f7c3d7856e7a), null)));
};






var $bq0iX = parcelRequire("bq0iX");


var $k6w4J = parcelRequire("k6w4J");


var $2C7m5 = parcelRequire("2C7m5");


var $13KEb = parcelRequire("13KEb");








var $ghftu = parcelRequire("ghftu");


var $inPa6 = parcelRequire("inPa6");


var $4KS7f = parcelRequire("4KS7f");


var $52EPl = parcelRequire("52EPl");


var $ahaN7 = parcelRequire("ahaN7");










var $4vC63 = parcelRequire("4vC63");


var $1OQlm = parcelRequire("1OQlm");


var $8a9Dm = parcelRequire("8a9Dm");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");











var $dAYOx = parcelRequire("dAYOx");

/* TabItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $bDrnk = parcelRequire("bDrnk");

const $1e2f36328512b138$var$HorizontalNavItemLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1o8l _9oik1r31 _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $1e2f36328512b138$export$17043b9d35150718 = ({ label: label, href: href, isSelected: isSelected, isDropdown: isDropdown, onClick: onClick, index: index, setWidth: setWidth, size: size })=>{
    const ref = (0, $42omo.useRef)(null);
    const { onKeyDown: onKeyDown, tabIndex: tabIndex, ...tabAttributes } = (0, $bDrnk.default)();
    const dropdownStyles = isDropdown ? {
        color: isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text, #292A2E)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        fontFamily: 'var(--ds-font-family-body, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
        paddingBottom: "var(--ds-space-075, 6px)",
        borderBottom: isSelected ? `${"var(--ds-border-width-selected, 2px)"} solid` : '0px'
    } : null;
    const tabId = `space-settings-inner-nav-tabs-${index ? index + 1 : 1}`;
    const tabAttributesWithAccessibility = {
        ...tabAttributes,
        id: tabId,
        'aria-controls': tabId,
        'aria-posinset': index ? index + 1 : 1,
        'aria-setsize': size
    };
    (0, $42omo.useLayoutEffect)(()=>{
        if (setWidth && ref.current) setWidth(ref.current.offsetWidth, index);
    }, [
        setWidth,
        index
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1e2f36328512b138$var$HorizontalNavItemLink, {
        href: href,
        ...tabAttributesWithAccessibility,
        "aria-selected": isSelected,
        onClick: onClick,
        ref: ref,
        // space is limited. Instead, we manually overflow tabs into a "More" dropdown menu.
        // Adding these styles in the styled.a component results in them being overridden by
        // Atlaskit; we must directly pass in style object to successfully override.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...dropdownStyles,
            overflow: 'visible',
            textOverflow: 'unset'
        }
    }, label);
};


const $c5f6763032ad37a6$export$55f02d4ed7f2ad28 = ({ condition: condition, children: children })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
const $c5f6763032ad37a6$export$51c8481edcf97103 = ({ webItems: webItems, setWidth: setWidth, createClickEvent: createClickEvent, innerNavigationWebItem: innerNavigationWebItem, isDropdown: isDropdown })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, webItems.map(({ completeKey: completeKey, label: label, url: url, id: id }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c5f6763032ad37a6$export$55f02d4ed7f2ad28, {
            key: completeKey,
            condition: isDropdown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2f36328512b138$export$17043b9d35150718), {
            key: completeKey,
            label: label,
            // We don't track state of these tabs from WebItems since they are all legacy
            // monolith pages, which require a full page reload on click
            isSelected: completeKey === innerNavigationWebItem?.completeKey,
            href: url ?? '',
            onClick: createClickEvent(completeKey || id),
            isDropdown: isDropdown,
            index: index,
            setWidth: setWidth,
            size: webItems.length
        }))));












var $9fBoq = parcelRequire("9fBoq");








var $eXaFc = parcelRequire("eXaFc");



const $06b3737204aac71d$export$5ca465c873c8408 = ({ apps: apps, setWidth: setWidth, createClickEvent: createClickEvent, forgeAppId: forgeAppId, forgeEnvId: forgeEnvId, forgeRoutePath: forgeRoutePath, spaceKey: spaceKey, isDropdown: isDropdown })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, apps.map((app, index)=>{
        const title = (0, $9fBoq.extensionTitle)(app);
        const appId = (0, $8a9Dm.getAppId)(app);
        const isSelected = (0, $k6w4J.isForgeAppMatchingRoute)(app, forgeAppId, forgeEnvId, forgeRoutePath);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5f6763032ad37a6$export$55f02d4ed7f2ad28), {
            key: app.id,
            condition: isDropdown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
            module: app
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2f36328512b138$export$17043b9d35150718), {
            key: app.id,
            label: title,
            isSelected: isSelected,
            href: (0, $1NBp8.SPACE_SETTINGS_FORGE_APPS).toUrl({
                spaceKey: spaceKey,
                appId: appId,
                envId: app.environmentId,
                forgeManifestRoute: app.properties?.route
            }),
            onClick: createClickEvent((0, $8a9Dm.getAppId)(app), (0, $eXaFc.ANALYTICS_SOURCE)),
            isDropdown: isDropdown,
            index: index,
            setWidth: setWidth
        })));
    }));



var $fZYO5 = parcelRequire("fZYO5");




const $51b62eacc3d6a669$var$APPROX_OVERFLOW_BUTTON_WIDTH = 75;
const $51b62eacc3d6a669$export$509f0882c63781d4 = (isSelected, currentTheme, themeProps)=>{
    const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            width: 'auto',
            textDecoration: 'none',
            marginTop: "var(--ds-space-075, 6px)",
            color: isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text, #292A2E)",
            background: 'none',
            '&:hover': {
                textDecoration: 'none',
                color: "var(--ds-text-selected, #1868DB)"
            }
        },
        spinnerStyles: // required by TS
        spinnerStyles
    };
};
function $51b62eacc3d6a669$var$howManyTabsFit(individualTabWidths, availableWidth) {
    let numberTabs = 0, totalWidthTabs = 0;
    for(let i = 0; i < individualTabWidths.length; i++){
        // Report back how much width we
        totalWidthTabs += individualTabWidths[i];
        if (totalWidthTabs > availableWidth) break;
        numberTabs++;
    }
    return {
        numberTabs: numberTabs,
        totalWidthTabs: totalWidthTabs
    };
}
const $51b62eacc3d6a669$export$cf5bbdb67115097f = ({ width: width, webItems: webItems, innerNavigationWebItem: innerNavigationWebItem, forgeAppId: forgeAppId, forgeEnvId: forgeEnvId, forgeRoutePath: forgeRoutePath, onLoadForgeError: onLoadForgeError, showForgeAppTabs: showForgeAppTabs, onLoadForgeApps: onLoadForgeApps, spaceKey: spaceKey })=>{
    // Forge apps will be loaded by a child component and set into state locally.
    const [forgeApps, setForgeApps] = (0, $42omo.useState)([]); // Store how many tabs we can show on screen, based on their widths + the available nav width.
    // webItems and Forge apps load asynchronously, so we store and calculate their widths separately.
    const [maxWebItemTabs, setMaxWebItemTabs] = (0, $42omo.useState)(webItems.length);
    const [maxForgeTabs, setMaxForgeTabs] = (0, $42omo.useState)(null); // Once tabs have rendered, we store each one's calculated width into an ordered array here
    // for comparison against the available nav width. We don't want this to trigger a rerender.
    const webItemTabWidths = (0, $42omo.useRef)([]).current;
    const forgeTabWidths = (0, $42omo.useRef)([]).current;
    const { push: push } = (0, $dPJCf.useRouteActions)();
    (0, $42omo.useLayoutEffect)(()=>{
        // Account for some extra room needed on the nav for the overflow button
        const availableWidth = Math.max(width - $51b62eacc3d6a669$var$APPROX_OVERFLOW_BUTTON_WIDTH, 0);
        if (availableWidth && webItems.length === webItemTabWidths.length && forgeApps.length === forgeTabWidths.length) {
            const { numberTabs: allowedWebItemTabs, totalWidthTabs: totalWidthTabs } = $51b62eacc3d6a669$var$howManyTabsFit(webItemTabWidths, availableWidth);
            setMaxWebItemTabs(allowedWebItemTabs); // Only calculate and set width of Forge tabs once we're sure Forge apps have loaded - this happens
            // asynchronously from the webItems above
            if (forgeApps.length) {
                const { numberTabs: allowedForgeAppTabs } = $51b62eacc3d6a669$var$howManyTabsFit(// webItem tabs appear first, decreasing the available width for Forge app tabs
                forgeTabWidths, availableWidth - totalWidthTabs);
                setMaxForgeTabs(allowedForgeAppTabs);
            }
        }
    }, [
        // Run this update when width changes (e.g. due to window resize), or when webItems or forgeApps change/load
        webItemTabWidths,
        webItems.length,
        width,
        forgeApps,
        forgeTabWidths
    ]); // In order for us to calculate how many tabs can be shown on screen, we must first know the length of
    // each tab - this is dynamic as tab number and length depends on our providers (webItems, Forge) and
    // includes configurable plugins. There is no max width set on individual tabs.
    // To know the length of each tab, we must render each tab on screen, at which point the setWidth callback
    // will be invoked, and we will know exactly how much space we have for each tab whenever the window is resized.
    // So the first render for webItemTabs and forgeAppTabs respectively MUST include ALL tabs in each set.
    // Then, we will calculate the available width and update state, triggering a rerender that pushes any
    // "leftover" tabs from each set into the overflow menu.
    // On first render, maxWebItemTabs == webItems.length so we will show all of them. maxWebItemTabs will then
    // be calculated and reset in useLayoutEffect.
    const webItemTabsToShow = webItems.slice(0, maxWebItemTabs);
    const leftoverWebItemTabs = webItems.slice(maxWebItemTabs); // Forge app tabs load separately from and more slowly than webItem tabs above, so we store their max #
    // separately. Even if all webItem tabs have loaded and some are pushed to the overflow menu, we must display
    // every Forge app tab during the first render where we have Forge app data (maxForgeTabs == null), so that we
    // can gather the individual width of each tab via setWidth. Then when useLayoutEffect runs we calculate the
    // actual available width, set maxForgeTabs == some number, and this will trigger a rerender upon which the
    // right number of Forge tabs will be pushed to overflow menu here.
    // Forge tabs always appear *after* webItem tabs.
    const forgeNumAllowedTabs = maxForgeTabs === null ? forgeApps.length : maxForgeTabs;
    const forgeTabsToShow = forgeApps.slice(0, forgeNumAllowedTabs);
    const leftoverForgeItemTabs = forgeApps.slice(forgeNumAllowedTabs);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleSetWebItemTabWidth = (tabWidth, index)=>{
        webItemTabWidths[index] = tabWidth;
    };
    const handleSetForgeTabWidth = (tabWidth, index)=>{
        forgeTabWidths[index] = tabWidth;
    };
    const handleLoadForgeApps = (apps)=>{
        // Apps blocked by App Access Rule should be hidden in tabs. As a result we filter
        // out all blocked apps before performing any display calculations.
        const appsAllowedByAppAccessRule = apps.filter((app)=>!(0, $1OQlm.isBlockedByAppAccessRule)(app));
        setForgeApps(appsAllowedByAppAccessRule);
        onLoadForgeApps && onLoadForgeApps(appsAllowedByAppAccessRule);
    };
    const createClickEvent = (clickedTabKey, source)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'spaceSettingsInnerNavLink',
                    source: source || (0, $fZYO5.ANALYTICS_SOURCE),
                    attributes: {
                        linkId: clickedTabKey
                    }
                }
            }).fire();
        };
    const isDropdownButtonSelected = Boolean(innerNavigationWebItem?.completeKey && leftoverWebItemTabs.some((item)=>item.completeKey === innerNavigationWebItem.completeKey) || leftoverForgeItemTabs.some((app)=>(0, $k6w4J.isForgeAppMatchingRoute)(app, forgeAppId, forgeEnvId, forgeRoutePath)));
    const forgeKeyboardShortcuts = forgeApps.map((f)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
            key: f.id,
            module: f,
            action: ()=>push((0, $1NBp8.SPACE_SETTINGS_FORGE_APPS).toUrl({
                    spaceKey: spaceKey,
                    appId: (0, $8a9Dm.getAppId)(f),
                    envId: f.environmentId,
                    forgeManifestRoute: f.properties?.route
                }))
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.EXTENSION_POINT_SPACE_SETTINGS_TABS_EXPERIENCE)
    }), forgeKeyboardShortcuts, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5f6763032ad37a6$export$51c8481edcf97103), {
        webItems: webItemTabsToShow,
        createClickEvent: createClickEvent,
        innerNavigationWebItem: innerNavigationWebItem,
        isDropdown: false,
        setWidth: handleSetWebItemTabWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $06b3737204aac71d$export$5ca465c873c8408), {
        apps: forgeTabsToShow.filter((0, $2C7m5.isNonNullable)),
        createClickEvent: createClickEvent,
        forgeAppId: forgeAppId,
        forgeEnvId: forgeEnvId,
        forgeRoutePath: forgeRoutePath,
        spaceKey: spaceKey,
        isDropdown: false,
        setWidth: handleSetForgeTabWidth
    }), leftoverWebItemTabs.length || leftoverForgeItemTabs.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                ...props,
                theme: (currentTheme, themeProps)=>$51b62eacc3d6a669$export$509f0882c63781d4(isDropdownButtonSelected, currentTheme, themeProps),
                spacing: "compact",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "",
                    size: "small"
                }),
                shouldFitContainer: true,
                ref: triggerRef,
                testId: "space-settings-tabs-more"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "space-settings.navigation.tabs.overflow-button",
                defaultMessage: "More"
            })),
        shouldFlip: false,
        placement: "bottom-end",
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        testId: "space-settings-tabs-more-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5f6763032ad37a6$export$51c8481edcf97103), {
        webItems: leftoverWebItemTabs,
        createClickEvent: createClickEvent,
        innerNavigationWebItem: innerNavigationWebItem,
        isDropdown: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $06b3737204aac71d$export$5ca465c873c8408), {
        apps: leftoverForgeItemTabs,
        createClickEvent: createClickEvent,
        forgeAppId: forgeAppId,
        forgeEnvId: forgeEnvId,
        forgeRoutePath: forgeRoutePath,
        spaceKey: spaceKey,
        isDropdown: true
    }))) : null, showForgeAppTabs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eXaFc.ForgeAppsLoader), {
        onLoadForgeApps: handleLoadForgeApps,
        onError: onLoadForgeError
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.EXTENSION_POINT_SPACE_SETTINGS_TABS_EXPERIENCE)
    }));
};



var $2EzwX = parcelRequire("2EzwX");


var $jMyy4 = parcelRequire("jMyy4");

const $4a04c57c8c82533e$var$SpaceSettingsNavigationV1SpaceSettingsNavigationQuery = (0, $c748160807ae1faa$export$2e2bcd8739ae039);
const $4a04c57c8c82533e$export$f7109619a5e9e0d6 = 'spaceSettingsV2InnerTabs'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a04c57c8c82533e$var$NavContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8mrlr _1bsb1osq _kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a04c57c8c82533e$var$TitleAndFilterBar = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1yb4 _16vwr2fv",
            __cmplp.className
        ])
    });
}); // Margin styles for this in TitleAndFilterBar above.
const $4a04c57c8c82533e$var$StyledTitle = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c810sd _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a04c57c8c82533e$var$FilterBarContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s8127j",
            __cmplp.className
        ])
    });
});
const $4a04c57c8c82533e$export$3c0052693cdf1569 = ({ children: children, spaceKey: spaceKey, onLoadForgeApps: onLoadForgeApps, forgeAppId: forgeAppId, forgeEnvId: forgeEnvId, forgeRoutePath: forgeRoutePath, onLoadForgeError: onLoadForgeError })=>{
    const [width, setWidth] = (0, $42omo.useState)(0);
    const onResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(setWidth, 200, {
        leading: false
    });
    const { location: location, matchRoute: matchRoute } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($4a04c57c8c82533e$var$SpaceSettingsNavigationV1SpaceSettingsNavigationQuery, {
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/space-settings"
    });
    const webItemSections = (0, $13KEb.useSpaceSettingsWebItemSectionsFromQuery)(data);
    const { innerNavigationWebItem: innerNavigationWebItem, outerNavigationWebItem: outerNavigationWebItem } = (0, $k6w4J.useSelectedNavigationWebItems)({
        matchRoute: matchRoute,
        location: location,
        webItemSections: webItemSections,
        skip: loading || !!error
    });
    if (loading) return null;
    else if (error) // Something went wrong; report it
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
     // we only show forge apps under one specific space settings page
    const showForgeAppTabs = outerNavigationWebItem?.id === (0, $k6w4J.FORGE_SPACE_SETTINGS_NAVIGATION_PARENT_WEBITEM);
    const showTitleAndNavTabs = innerNavigationWebItem?.completeKey !== (0, $13KEb.AUTOMATION_WEBITEM_KEY);
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const isSpaceOrHubPermsPage = (0, $k6w4J.isSpacePermissionsRoute)(matchRoute, location) || (0, $k6w4J.isHubPermissionsRoute)(matchRoute, location);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a04c57c8c82533e$var$NavContainer, null, webItemSections?.filter((0, $2C7m5.isNonNullable)).map((webItemSection)=>webItemSection.id === outerNavigationWebItem?.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: webItemSection.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: isCompanyHub ? (0, $3IBnw.Attribution).PERFORMANCE_INSIGHTS : (0, $3IBnw.Attribution).INHERIT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bq0iX.SpaceSettingsBreadcrumbs), {
            spaceKey: spaceKey,
            source: $4a04c57c8c82533e$export$f7109619a5e9e0d6,
            currentSection: webItemSection.id
        })), showTitleAndNavTabs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a04c57c8c82533e$var$TitleAndFilterBar, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a04c57c8c82533e$var$StyledTitle, null, webItemSection.label), !isCompanyHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a04c57c8c82533e$var$FilterBarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2EzwX.SpaceSettingsFilterBar), {
            spaceAlias: data?.space?.alias ?? null,
            spaceKey: spaceKey,
            source: $4a04c57c8c82533e$export$f7109619a5e9e0d6,
            forgeAppId: forgeAppId,
            forgeEnvId: forgeEnvId,
            forgeRoutePath: forgeRoutePath
        }))), isSpaceOrHubPermsPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee4e36fb9d07b3a4$export$6b7c6156afa05617), {
            spaceKey: spaceKey
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingInlineStart: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4A7Gn.default), {
            id: "space-settings-inner-nav-tabs"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0DTaW.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $51b62eacc3d6a669$export$cf5bbdb67115097f), {
            webItems: webItemSection.items?.filter((0, $2C7m5.isNonNullable)) ?? [],
            width: width,
            innerNavigationWebItem: innerNavigationWebItem,
            showForgeAppTabs: showForgeAppTabs,
            spaceKey: spaceKey,
            onLoadForgeApps: onLoadForgeApps,
            forgeAppId: forgeAppId,
            forgeEnvId: forgeEnvId,
            forgeRoutePath: forgeRoutePath,
            onLoadForgeError: onLoadForgeError
        }))))) : null, typeof children === 'function' ? children({
            withCompleteNav: showTitleAndNavTabs
        }) : children) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4JDbp.default), {
        setWidth: onResize,
        offscreen: true
    }));
};









var $cO1el = parcelRequire("cO1el");


var $6f0Oj = parcelRequire("6f0Oj");


var $ecnYn = parcelRequire("ecnYn");









var $iquRY = parcelRequire("iquRY");








var $877b2 = parcelRequire("877b2");

const $f1fc76d8070fd871$var$LEGACY_PDF_EXPORT_COMPLETEKEY = 'com.atlassian.confluence.extra.flyingpdf:configpdf';
const $f1fc76d8070fd871$var$i18n = (0, $aXWIB.defineMessages)({
    spaceDetailsPageTitle: {
        id: "space-settings.space-settings-navigation.space-details-page.title",
        defaultMessage: "Space details"
    }
});
const $f1fc76d8070fd871$var$NavContainerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    position: 'relative'
});
const $f1fc76d8070fd871$var$TitleAndFilterBarStyles = (0, $ecnYn.xcss)({
    marginBlockEnd: 'space.400'
});
const $f1fc76d8070fd871$var$getTitleFromWebItem = ({ webItemSection: webItemSection, itemCompleteKey: itemCompleteKey })=>{
    // Skip title rendering for PDF export page if NCS is enabled or in rollout - it will add its own title
    if (itemCompleteKey === $f1fc76d8070fd871$var$LEGACY_PDF_EXPORT_COMPLETEKEY && (0, $6mKj3.expValEquals)('confluence_pdf_ncs_enabled', 'isEnabled', true)) return null;
    const innerTitle = webItemSection?.items?.find((item)=>item?.completeKey === itemCompleteKey)?.label;
    const outerTitle = webItemSection?.label;
    return innerTitle || outerTitle;
};
const $f1fc76d8070fd871$var$getTitleFromPathname = ({ locationPathname: locationPathname, formatMessage: formatMessage })=>{
    if (locationPathname.includes('viewspacesummary.action') || locationPathname.includes('editspace.action') || locationPathname.includes('editspacelabels.action')) // This is a special case for the space details page, which doesn't have a web item section
    // now that it's been migrated to the new navigation. So we've hardcoded the title here until
    // we are able to uplift the page from the monolith, at which point it will no longer render
    // via this component.
    return formatMessage($f1fc76d8070fd871$var$i18n.spaceDetailsPageTitle);
    else return undefined;
};
const $f1fc76d8070fd871$export$3ffff1cd538d533c = ({ children: children, spaceKey: spaceKey })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { location: location, matchRoute: matchRoute } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const { loading: loading, error: error, webItemSections: webItemSections } = (0, $877b2.useSpaceSettingsWebItemSections)({
        spaceAlias: spaceKey
    });
    const { innerNavigationWebItem: innerNavigationWebItem, outerNavigationWebItem: outerNavigationWebItem } = (0, $k6w4J.useSelectedNavigationWebItems)({
        matchRoute: matchRoute,
        location: location,
        webItemSections: webItemSections,
        skip: loading || !!error
    });
    if (loading) return null;
    else if (error) // Something went wrong; report it
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    const isSpaceOrHubPermsPage = (0, $k6w4J.isSpacePermissionsRoute)(matchRoute, location) || (0, $k6w4J.isHubPermissionsRoute)(matchRoute, location);
    const matchingWebItemSection = webItemSections?.find((section)=>section?.id === outerNavigationWebItem?.id);
    const titleFromWebItem = $f1fc76d8070fd871$var$getTitleFromWebItem({
        webItemSection: matchingWebItemSection,
        itemCompleteKey: innerNavigationWebItem?.completeKey
    });
    const titleFromPathname = $f1fc76d8070fd871$var$getTitleFromPathname({
        locationPathname: location?.pathname || '',
        formatMessage: formatMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $f1fc76d8070fd871$var$NavContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, (titleFromWebItem || titleFromPathname) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $f1fc76d8070fd871$var$TitleAndFilterBarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large",
        as: "h1"
    }, titleFromWebItem || titleFromPathname)), isSpaceOrHubPermsPage && !isRbacEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ee4e36fb9d07b3a4$export$6b7c6156afa05617), {
        spaceKey: spaceKey
    })), typeof children === 'function' ? children({
        withCompleteNav: true
    }) : children);
};


const $809e500e1f629780$export$f7109619a5e9e0d6 = 'spaceSettingsV2InnerTabs';
const $809e500e1f629780$export$6304c9dce91152ae = (props)=>{
    if (!(0, $cEgMD.isCompanyHubSpaceKey)(props.spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1fc76d8070fd871$export$3ffff1cd538d533c), props);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4a04c57c8c82533e$export$3c0052693cdf1569), props);
};
module.exports["ANALYTICS_SOURCE"] = $809e500e1f629780$export$f7109619a5e9e0d6;
module.exports["SpaceSettingsNavigation"] = $809e500e1f629780$export$6304c9dce91152ae;

});

parcelRegister("amKzv", function(module, exports) {

let $78c01599984a3ffa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $78c01599984a3ffa$var$load("amPsT"),
    $78c01599984a3ffa$var$load("hOaAV"),
    $78c01599984a3ffa$var$load("1qlDN"),
    $78c01599984a3ffa$var$load("1yVM6"),
    $78c01599984a3ffa$var$load("6XCf4"),
    $78c01599984a3ffa$var$load("cEqm7"),
    $78c01599984a3ffa$var$load("5pvpJ"),
    $78c01599984a3ffa$var$load("hhss7"),
    $78c01599984a3ffa$var$load("bU3dV")
]).then(()=>parcelRequire('4noyo'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("bq0iX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $laHi9 = parcelRequire("laHi9");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");

const $87f19d831ee4372e$var$i18n = (0, $aXWIB.defineMessages)({
    spaceSettingsLink: {
        id: "breadcrumbs.navigation.space-settings-breadcrumb-link.landing-page",
        defaultMessage: "Space settings"
    },
    hubLink: {
        id: "breadcrumbs.navigation.space-settings-breadcrumb-link.hub-name",
        defaultMessage: "{hubName, select, other {{hubName}} undefined {Company Hub}}"
    },
    hubSettingsLink: {
        id: "breadcrumbs.navigation.space-settings-breadcrumb-link.hub-settings",
        defaultMessage: "Company Hub settings"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $87f19d831ee4372e$var$BreadcrumbLinkStyledText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _k48pi7a9 _syazazsu _ca0qv77o _1e0c1o8l _9oik1r31 _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _k48pi7a9 _syazazsu _ca0qv77o _1e0c1o8l _9oik1r31 _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $87f19d831ee4372e$export$75232dfc2fbecee0 = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceSettingsBreadcrumbs(t0) {
    const $ = (0, $frIzR.c)(5);
    let props;
    let spaceKey;
    if ($[0] !== t0) {
        ({ spaceKey: spaceKey, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = spaceKey;
    } else {
        props = $[1];
        spaceKey = $[2];
    }
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) {
        let t1;
        if ($[3] !== props) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f19d831ee4372e$var$HubLink, props);
            $[3] = props;
            $[4] = t1;
        } else t1 = $[4];
        return t1;
    }
    return null;
} : function SpaceSettingsBreadcrumbs({ spaceKey: spaceKey, ...props }) {
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f19d831ee4372e$var$HubLink, props);
    return null;
};
const $87f19d831ee4372e$var$Link = (0, $3u0dr.isReactCompilerActiveV2)() ? function Link(t0) {
    const $ = (0, $frIzR.c)(11);
    const { currentSection: currentSection, href: href, source: source, children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== currentSection || $[2] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "spaceSettingsBreadcrumbLink",
                    source: source,
                    attributes: {
                        currentSection: currentSection
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = currentSection;
        $[2] = source;
        $[3] = t1;
    } else t1 = $[3];
    const onClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
            label: "",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        });
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f19d831ee4372e$var$BreadcrumbLinkStyledText, null, children);
        $[5] = children;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== href || $[8] !== onClick || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("nav", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            href: href,
            onClick: onClick,
            iconBefore: t2,
            appearance: "subtle-link",
            spacing: "none"
        }, t3));
        $[7] = href;
        $[8] = onClick;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : function Link({ currentSection: currentSection, href: href, source: source, children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'spaceSettingsBreadcrumbLink',
                source: source,
                attributes: {
                    currentSection: currentSection
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("nav", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        href: href,
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
            label: "",
            color: "var(--ds-icon, #292A2E)",
            size: "small"
        }),
        appearance: "subtle-link",
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f19d831ee4372e$var$BreadcrumbLinkStyledText, null, children)));
};
function $87f19d831ee4372e$var$HubLink(props) {
    const { current: current } = (0, $dPJCf.useRouteDataRef)();
    const routeMatch = {
        name: current?.routeName,
        params: current?.routeParams
    };
    const history = (0, $dPJCf.useHistory)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { companyHubName: companyHubName } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    let href;
    let text; // The Company Hub app-like experience doesn't have side nav implemented yet so it needs a breadcrumb/link for now.
    if (routeMatch?.name === (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name && routeMatch?.params?.tab) {
        href = (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).toUrl();
        text = formatMessage($87f19d831ee4372e$var$i18n.hubSettingsLink);
    }
    href ?? (href = history?.location?.state?.['from'] === (0, $1NBp8.COMPANY_HUB_EDIT).name ? (0, $1NBp8.COMPANY_HUB_EDIT).toUrl() : (0, $1NBp8.COMPANY_HUB).toUrl());
    text ?? (text = formatMessage($87f19d831ee4372e$var$i18n.hubLink, {
        hubName: companyHubName || undefined
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($87f19d831ee4372e$var$Link, {
        ...props,
        href: href
    }, text);
}
module.exports["SpaceSettingsBreadcrumbs"] = $87f19d831ee4372e$export$75232dfc2fbecee0;

});

parcelRegister("2C7m5", function(module, exports) {
function $2ba8d2147757b4b1$export$826fff653a329e83(x) {
    return Boolean(x);
}
module.exports["isNonNullable"] = $2ba8d2147757b4b1$export$826fff653a329e83;

});

parcelRegister("13KEb", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $aXWIB = parcelRequire("aXWIB");


var $1NBp8 = parcelRequire("1NBp8");


var $9wGTI = parcelRequire("9wGTI");


var $cEgMD = parcelRequire("cEgMD");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $cLo2u = parcelRequire("cLo2u");


var $i28ZW = parcelRequire("i28ZW");


var $2C7m5 = parcelRequire("2C7m5");


var $k6w4J = parcelRequire("k6w4J");








var $3P1RK = parcelRequire("3P1RK");





var $iquRY = parcelRequire("iquRY");
















/**
 * Shared prefix used to build `completeKey` values for space-settings web items
 * that are injected by the Confluence frontend (as opposed to server-rendered or plugin items).
 *
 * Defined once here to prevent silent breakage if the prefix ever changes.
 */ const $1963be5f8bbc5473$export$1fd39dfe344a716e = 'confluence-frontend.';


const $06d067ca6d2195d0$export$d4bd26a59527e878 = '-system.space.tools-permissions';
const $06d067ca6d2195d0$var$USERS_TAB_ID = 'space-permissions-users';
const $06d067ca6d2195d0$var$GROUPS_TAB_ID = 'space-permissions-groups';
const $06d067ca6d2195d0$var$GUESTS_TAB_ID = 'space-permissions-guests';
const $06d067ca6d2195d0$export$c5c5e2ecb1099827 = 'space-permissions-anonymous-access';
const { GENERAL_PERMISSIONS_WEBITEM_COMPLETE_KEY: $06d067ca6d2195d0$var$GENERAL_PERMISSIONS_WEBITEM_COMPLETE_KEY } = (0, $k6w4J.KeysOfWebItemsWithExtraUrls);
const $06d067ca6d2195d0$var$i18n = (0, $aXWIB.defineMessages)({
    spacePermissionsWebItemUsersLink: {
        id: "space-settings.web-item-section.space-permissions.web-item.users",
        defaultMessage: "Users"
    },
    spacePermissionsWebItemGroupsLink: {
        id: "space-settings.web-item-section.space-permissions.web-item.groups",
        defaultMessage: "Groups"
    },
    spacePermissionsWebItemTeamsAndGroupsLink: {
        id: "space-settings.web-item-section.space-permissions.web-item.teamsgroups",
        defaultMessage: "Teams and groups"
    },
    spacePermissionsWebItemGuestsLink: {
        id: "space-settings.web-item-section.space-permissions.web-item.guests",
        defaultMessage: "Guests"
    },
    spacePermissionsWebItemAnonymousAccessLink: {
        id: "space-settings.web-item-section.space-permissions.web-item.anonymous-access",
        defaultMessage: "Anonymous access"
    },
    hubPermissionsWebItemSectionTitle: {
        id: "space-settings.web-item-section.hub-permissions.web-item.title",
        defaultMessage: "Hub permissions"
    }
});
const $06d067ca6d2195d0$var$addSpacePermissionsWebItems = (itemsToAdd, section)=>{
    if (!section || !itemsToAdd?.length) return section;
    //remove the "General" link and add the rest of the space permissions tabs
    const isGeneralLink = (item)=>item?.completeKey == $06d067ca6d2195d0$var$GENERAL_PERMISSIONS_WEBITEM_COMPLETE_KEY;
    const generalLinkIndex = section.items.findIndex(isGeneralLink);
    if (generalLinkIndex !== -1) {
        // XXX Don't mutate the input section! May be shared across invocations.
        const items = [
            ...section.items
        ];
        items.splice(generalLinkIndex, 1, ...itemsToAdd);
        return {
            ...section,
            items: items
        };
    }
    return section;
};
const $06d067ca6d2195d0$export$3eafcac383b16a02 = ({ webItemSections: webItemSections, isSpaceAdmin: isSpaceAdmin })=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const sectionIndex = webItemSections?.findIndex((section)=>section?.id === $06d067ca6d2195d0$export$d4bd26a59527e878) ?? -1;
    const inputSection = webItemSections?.[sectionIndex] ?? null;
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const { canManageNonlicensedUsers: canManageNonlicensedUsers, canManageUsers: canManageUsers } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: isRbacEnabled || (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? false : undefined
    });
    const outputSection = $06d067ca6d2195d0$var$useSpacePermissionsWebItemSection(spaceKey, inputSection, isSpaceAdmin, isRbacEnabled, canManageNonlicensedUsers, canManageUsers);
    if (inputSection && inputSection !== outputSection && webItemSections) {
        // XXX Don't mutate the input webItemSections! May be shared across invocations.
        const result = [
            ...webItemSections
        ];
        result[sectionIndex] = outputSection;
        return result;
    }
    return webItemSections;
};
const $06d067ca6d2195d0$var$ANALYTICS_PLUGIN_WEB_ITEM_COMPLETE_KEY = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics__analytics-permissions-space-tools-tab';
const $06d067ca6d2195d0$var$ADDON_SPACE_PERMISSIONS_COMPLETE_KEY = 'confluence.sections.space.tools.v2:addonspacepermissions';
function $06d067ca6d2195d0$var$useSpacePermissionsWebItemSection(spaceKey, section, isSpaceAdmin, isRbacEnabled, canManageNonlicensedUsers, canManageUsers) {
    const intl = (0, $aXWIB.useIntl)();
    if (!section) return section;
    let result = section;
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub) // Company Hub hides its space from the user so the label/title "Space
    // permissions" is undesirable.
    result = {
        ...result,
        label: intl.formatMessage($06d067ca6d2195d0$var$i18n.hubPermissionsWebItemSectionTitle)
    };
    if (!spaceKey) return result;
    const getPermissionSettingsWebItems = (route)=>[
            {
                id: $06d067ca6d2195d0$var$USERS_TAB_ID,
                label: intl.formatMessage($06d067ca6d2195d0$var$i18n.spacePermissionsWebItemUsersLink),
                url: route.toUrl({
                    spaceKey: spaceKey,
                    tab: (0, $3P1RK.SpacePermissionsTabKey).Users
                }),
                completeKey: (0, $1963be5f8bbc5473$export$1fd39dfe344a716e) + $06d067ca6d2195d0$var$USERS_TAB_ID,
                icon: null
            },
            {
                id: $06d067ca6d2195d0$var$GROUPS_TAB_ID,
                label: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? intl.formatMessage($06d067ca6d2195d0$var$i18n.spacePermissionsWebItemTeamsAndGroupsLink) : intl.formatMessage($06d067ca6d2195d0$var$i18n.spacePermissionsWebItemGroupsLink),
                url: route.toUrl({
                    spaceKey: spaceKey,
                    tab: (0, $3P1RK.SpacePermissionsTabKey).Groups
                }),
                completeKey: (0, $1963be5f8bbc5473$export$1fd39dfe344a716e) + $06d067ca6d2195d0$var$GROUPS_TAB_ID,
                icon: null
            },
            {
                id: $06d067ca6d2195d0$var$GUESTS_TAB_ID,
                label: intl.formatMessage($06d067ca6d2195d0$var$i18n.spacePermissionsWebItemGuestsLink),
                url: route.toUrl({
                    spaceKey: spaceKey,
                    tab: (0, $3P1RK.SpacePermissionsTabKey).Guests
                }),
                completeKey: (0, $1963be5f8bbc5473$export$1fd39dfe344a716e) + $06d067ca6d2195d0$var$GUESTS_TAB_ID,
                icon: null
            },
            {
                id: $06d067ca6d2195d0$export$c5c5e2ecb1099827,
                label: intl.formatMessage($06d067ca6d2195d0$var$i18n.spacePermissionsWebItemAnonymousAccessLink),
                url: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
                    spaceKey: spaceKey,
                    tab: (0, $3P1RK.SpacePermissionsTabKey).AnonymousAccess
                }),
                completeKey: (0, $1963be5f8bbc5473$export$1fd39dfe344a716e) + $06d067ca6d2195d0$export$c5c5e2ecb1099827,
                icon: null
            }
        ];
    const itemsToAdd = getPermissionSettingsWebItems(isCompanyHub ? (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS) : (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS));
    const nextSection = $06d067ca6d2195d0$var$addSpacePermissionsWebItems(itemsToAdd, result);
    result = nextSection ?? result;
    // Filter out analytics permissions item: when experiment use MANAGE_USERS (canManageUsers), else space admin
    const canSeeAnalytics = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? canManageUsers : isSpaceAdmin;
    if (!canSeeAnalytics) result = {
        ...result,
        items: result.items?.filter((item)=>item?.completeKey !== $06d067ca6d2195d0$var$ANALYTICS_PLUGIN_WEB_ITEM_COMPLETE_KEY)
    };
    // Apps: always shown
    const canSeeApps = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? canManageUsers : true;
    result = {
        ...result,
        items: result.items?.filter((item)=>item?.completeKey !== $06d067ca6d2195d0$var$ADDON_SPACE_PERMISSIONS_COMPLETE_KEY || canSeeApps)?.map((item)=>{
            if (item?.completeKey === $06d067ca6d2195d0$var$ADDON_SPACE_PERMISSIONS_COMPLETE_KEY && canSeeApps) return {
                ...item,
                url: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
                    spaceKey: spaceKey,
                    tab: (0, $3P1RK.SpacePermissionsTabKey).Apps
                })
            };
            return item;
        })
    };
    if (isCompanyHub) {
        // Only keep Users, Groups, and Guests tabs for Company Hub.
        const allowedTabs = [
            $06d067ca6d2195d0$var$USERS_TAB_ID,
            $06d067ca6d2195d0$var$GROUPS_TAB_ID,
            $06d067ca6d2195d0$var$GUESTS_TAB_ID
        ];
        result = {
            ...result,
            items: result.items?.filter((item)=>item?.id && allowedTabs.includes(item.id))
        };
    } else if (isRbacEnabled) {
        //if RBAC is enabled, we want to actually remove the users, groups, and guests tabs
        const excludedTabs = [
            $06d067ca6d2195d0$var$USERS_TAB_ID,
            $06d067ca6d2195d0$var$GROUPS_TAB_ID,
            $06d067ca6d2195d0$var$GUESTS_TAB_ID
        ];
        // Also exclude anonymous access tab if user doesn't have manage_nonlicensed_users permission
        if (!canManageNonlicensedUsers) excludedTabs.push($06d067ca6d2195d0$export$c5c5e2ecb1099827);
        result = {
            ...result,
            items: result.items?.filter((item)=>!item?.id || !excludedTabs.includes(item.id))
        };
    }
    return result;
}

























const $8c11d5474368d0f0$export$cf501a10c290cb24 = 'space-public-links';
const $8c11d5474368d0f0$var$i18n = (0, $aXWIB.defineMessages)({
    spacePermissionsWebItemPublicLinksLink: {
        id: "space-settings.web-item-section.space-permissions.web-item.public-links",
        defaultMessage: "Public links"
    }
});
const $8c11d5474368d0f0$var$addPublicLinksWebItem = (publicLinksWebItem, webItemSections)=>{
    return webItemSections?.map((section)=>{
        if (section?.id === (0, $06d067ca6d2195d0$export$d4bd26a59527e878)) {
            // XXX Don't mutate the input webItemSections! May be shared across invocations.
            const [firstItem, ...restItems] = section.items;
            return {
                ...section,
                items: [
                    firstItem,
                    publicLinksWebItem,
                    ...restItems
                ]
            };
        }
        return section;
    });
};
const $8c11d5474368d0f0$export$98e0bba00ee80f6f = ({ webItemSections: webItemSections })=>{
    const intl = (0, $aXWIB.useIntl)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const isRbacOrExperimentEnabled = isRbacEnabled || (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const { canManagePublicLinks: canManagePublicLinks } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey || !isRbacOrExperimentEnabled
    });
    if (!spaceKey) return webItemSections;
    if (isRbacOrExperimentEnabled && !canManagePublicLinks) return webItemSections;
    if ((0, $6mKj3.expValEquals)('cc_perms_mvp_shareable_links_ui', 'isEnabled', true)) return webItemSections;
    const publicLinksWebItem = {
        id: $8c11d5474368d0f0$export$cf501a10c290cb24,
        label: intl.formatMessage($8c11d5474368d0f0$var$i18n.spacePermissionsWebItemPublicLinksLink),
        url: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
            spaceKey: spaceKey,
            tab: (0, $3P1RK.SpacePermissionsTabKey).PublicLinks
        }),
        completeKey: (0, $1963be5f8bbc5473$export$1fd39dfe344a716e) + $8c11d5474368d0f0$export$cf501a10c290cb24,
        icon: null
    };
    return $8c11d5474368d0f0$var$addPublicLinksWebItem(publicLinksWebItem, webItemSections);
};























const $4eea9b9f092ef5ea$export$4cc41986c9630ffa = 'space-settings-shareable-links';
const $4eea9b9f092ef5ea$var$i18n = (0, $aXWIB.defineMessages)({
    spacePermissionsWebItemShareableLinksLink: {
        id: "space-settings.web-item-section.space-permissions.web-item.shared-links.non-final",
        defaultMessage: "Access links"
    }
});
const $4eea9b9f092ef5ea$var$addShareableLinksWebItem = (shareableLinksWebItem, webItemSections)=>{
    return webItemSections?.map((section)=>{
        if (section?.id === (0, $06d067ca6d2195d0$export$d4bd26a59527e878)) {
            const publicLinksIndex = section.items.findIndex((item)=>item?.id === (0, $8c11d5474368d0f0$export$cf501a10c290cb24));
            const anonymousIndex = section.items.findIndex((item)=>item?.id === (0, $06d067ca6d2195d0$export$c5c5e2ecb1099827));
            let anchorIndex;
            if (publicLinksIndex !== -1) anchorIndex = publicLinksIndex;
            else if (anonymousIndex !== -1) anchorIndex = anonymousIndex;
            else anchorIndex = section.items.length - 1;
            const insertAt = anchorIndex + 1;
            // XXX Don't mutate the input webItemSections! May be shared across invocations.
            const items = [
                ...section.items.slice(0, insertAt),
                shareableLinksWebItem,
                ...section.items.slice(insertAt)
            ];
            return {
                ...section,
                items: items
            };
        }
        return section;
    });
};
const $4eea9b9f092ef5ea$export$7c1851345f26e096 = ({ webItemSections: webItemSections })=>{
    const intl = (0, $aXWIB.useIntl)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const isRbacOrExperimentEnabled = isRbacEnabled || (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const { canManagePublicLinks: canManagePublicLinks } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey || !isRbacOrExperimentEnabled
    });
    if (!spaceKey) return webItemSections;
    if (isRbacOrExperimentEnabled && !canManagePublicLinks) return webItemSections;
    if (!(0, $6mKj3.expValEquals)('cc_perms_mvp_shareable_links_ui', 'isEnabled', true)) return webItemSections;
    const shareableLinksWebItem = {
        id: $4eea9b9f092ef5ea$export$4cc41986c9630ffa,
        label: intl.formatMessage($4eea9b9f092ef5ea$var$i18n.spacePermissionsWebItemShareableLinksLink),
        url: (0, $1NBp8.SPACE_SETTINGS_SHAREABLE_LINKS).toUrl({
            spaceKey: spaceKey
        }),
        completeKey: (0, $1963be5f8bbc5473$export$1fd39dfe344a716e) + $4eea9b9f092ef5ea$export$4cc41986c9630ffa,
        icon: null
    };
    return $4eea9b9f092ef5ea$var$addShareableLinksWebItem(shareableLinksWebItem, webItemSections);
};









var $lxdLN = parcelRequire("lxdLN");


var $9svYf = parcelRequire("9svYf");




const $2de1cae442b950e2$export$500127bed67c4a34 = '-system.space.tools-overview';
const $2de1cae442b950e2$export$e3d94edf845ca145 = 'space-export-space';
const $2de1cae442b950e2$var$exportSpaceMessage = (0, $aXWIB.defineMessage)({
    id: "space-settings.web-item-section.space-permissions.web-item.export-space",
    defaultMessage: "Export space"
});
const $2de1cae442b950e2$var$addExportSpaceWebItem = (exportSpaceWebItem, webItemSections)=>{
    if (!exportSpaceWebItem) return webItemSections;
    return webItemSections?.map((section)=>{
        if (section?.id === $2de1cae442b950e2$export$500127bed67c4a34) {
            // XXX Don't mutate the input webItemSections! May be shared across invocations.
            const items = section.items.map((item)=>item?.completeKey === 'confluence.sections.space.tools.v2:export' ? exportSpaceWebItem : item);
            return {
                ...section,
                items: items
            };
        }
        return section;
    });
};
const $2de1cae442b950e2$export$771e5d446ad72896 = ({ space: space, webItemSections: webItemSections })=>{
    const intl = (0, $aXWIB.useIntl)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const spaceId = space?.id;
    const { exportPolicyState: exportPolicyState } = (0, $9svYf.useExportEnabledState)(spaceId);
    if (!spaceKey || !spaceId || exportPolicyState === (0, $lxdLN.ExportPolicyEnum).LOADING || exportPolicyState === (0, $lxdLN.ExportPolicyEnum).ENABLED) return webItemSections;
    const exportSpaceWebItem = {
        id: $2de1cae442b950e2$export$e3d94edf845ca145,
        label: intl.formatMessage($2de1cae442b950e2$var$exportSpaceMessage),
        url: (0, $1NBp8.SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE).toUrl({
            spaceKey: spaceKey
        }),
        completeKey: null,
        icon: null
    };
    return $2de1cae442b950e2$var$addExportSpaceWebItem(exportSpaceWebItem, webItemSections);
};














const $6421ce7c16285904$var$SPACE_LOOK_AND_FEEL_WEBITEM_SECTION_ID = '-system.space.tools-lookandfeel';
const $6421ce7c16285904$var$LEGACY_THEME_COMPLETEKEY = 'confluence.sections.space.tools.v2:choosetheme';
const $6421ce7c16285904$var$LEGACY_TEMPLATES_COMPLETEKEY = 'com.atlassian.confluence.plugins.confluence-templates:space-templates-v2';
const $6421ce7c16285904$var$LEGACY_PAGE_LAYOUT_COMPLETEKEY = 'confluence.sections.space.tools.v2:custompagecontent';
const $6421ce7c16285904$var$LEGACY_PDF_EXPORT_COMPLETEKEY = 'com.atlassian.confluence.extra.flyingpdf:configpdf';
const $6421ce7c16285904$var$i18n = (0, $aXWIB.defineMessages)({
    pageLayoutTitle: {
        id: "space-settings.web-item-section.look-and-feel.web-item.page-layout",
        defaultMessage: "Layout"
    },
    pdfExportTitle: {
        id: "space-settings.web-item-section.look-and-feel.web-item.pdf-export",
        defaultMessage: "PDF export formatting"
    }
});
const $6421ce7c16285904$export$8f5961b682362946 = ({ webItemSections: webItemSections })=>{
    const intl = (0, $aXWIB.useIntl)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    if (!spaceKey) return webItemSections;
    return webItemSections?.map((section)=>{
        if (section?.id === $6421ce7c16285904$var$SPACE_LOOK_AND_FEEL_WEBITEM_SECTION_ID) return {
            ...section,
            items: section.items.map((item)=>{
                if (item?.completeKey === $6421ce7c16285904$var$LEGACY_THEME_COMPLETEKEY) return {
                    ...item,
                    url: (0, $1NBp8.SPACE_LOOK_AND_FEEL_SETTINGS).toUrl({
                        spaceKey: spaceKey,
                        tab: 'themes'
                    })
                };
                if (item?.completeKey === $6421ce7c16285904$var$LEGACY_TEMPLATES_COMPLETEKEY) return {
                    ...item,
                    url: (0, $1NBp8.SPACE_LOOK_AND_FEEL_SETTINGS).toUrl({
                        spaceKey: spaceKey,
                        tab: 'templates'
                    })
                };
                if (item?.completeKey === $6421ce7c16285904$var$LEGACY_PAGE_LAYOUT_COMPLETEKEY) return {
                    ...item,
                    label: intl.formatMessage($6421ce7c16285904$var$i18n.pageLayoutTitle),
                    url: (0, $1NBp8.SPACE_LOOK_AND_FEEL_SETTINGS).toUrl({
                        spaceKey: spaceKey,
                        tab: 'page-layout'
                    })
                };
                if (item?.completeKey === $6421ce7c16285904$var$LEGACY_PDF_EXPORT_COMPLETEKEY) return {
                    ...item,
                    ...(0, $6mKj3.expValEquals)('confluence_pdf_ncs_enabled', 'isEnabled', true) && {
                        label: intl.formatMessage($6421ce7c16285904$var$i18n.pdfExportTitle)
                    },
                    url: (0, $1NBp8.SPACE_LOOK_AND_FEEL_SETTINGS).toUrl({
                        spaceKey: spaceKey,
                        tab: 'pdf-export'
                    })
                };
                return item;
            })
        };
        return section;
    });
};


const $7266d6a19968ddba$export$b18ac9e6fbc862e3 = 'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.addons.automation.confluence__confluence-space-automation-rules';
const $7266d6a19968ddba$export$26aa0451233f62c3 = '-system.space.tools-com.atlassian.addons.automation.confluence__space-automation';
const $7266d6a19968ddba$export$f4c63696b5148d5d = 'space-automation-section';
const $7266d6a19968ddba$export$d4bd26a59527e878 = '-system.space.tools-permissions';
const $7266d6a19968ddba$export$30163b4bd8cf5751 = '-system.space.tools-overview';
const $7266d6a19968ddba$export$dcc056e0b27b15b = 'confluence.sections.space.tools.v2:spacedetails';
const $7266d6a19968ddba$export$4c8a9de856b86f95 = 'confluence.sections.space.tools.v2:spacedetails-personal';
const $7266d6a19968ddba$export$4afc3f9291a77027 = '-system.space.tools-contenttools';
const $7266d6a19968ddba$export$a81e47aa5897f9d = 'confluence.sections.space.tools.v2:content_manager';
const $7266d6a19968ddba$export$d6ee871af16ff724 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics__analytics-permissions-space-tools-tab';
const $7266d6a19968ddba$export$4943bf64e528def9 = (section)=>section?.id === $7266d6a19968ddba$export$26aa0451233f62c3 || section?.id === $7266d6a19968ddba$export$f4c63696b5148d5d;
const $7266d6a19968ddba$var$useManageSpaceWebItemSection = ({ webItemSections: webItemSections })=>{
    // XXX Don't mutate the input webItemSections! May be shared across invocations.
    return webItemSections?.filter((0, $2C7m5.isNonNullable)).map((section)=>{
        if (section.id === $7266d6a19968ddba$export$30163b4bd8cf5751) // Creates a new manage space web item section without the space details web item.
        return {
            ...section,
            items: section.items.filter((item)=>item?.completeKey !== $7266d6a19968ddba$export$dcc056e0b27b15b && item?.completeKey !== $7266d6a19968ddba$export$4c8a9de856b86f95)
        };
        else return section;
    });
};
const $7266d6a19968ddba$var$useManageContentWebItemSection = ({ webItemSections: webItemSections })=>{
    // XXX Don't mutate the input webItemSections! May be shared across invocations.
    return webItemSections?.filter((0, $2C7m5.isNonNullable)).map((section)=>{
        if (section.id === $7266d6a19968ddba$export$4afc3f9291a77027) // Creates a new manage content web item section without the content manager web item.
        return {
            ...section,
            items: section.items.filter((item)=>item?.completeKey !== $7266d6a19968ddba$export$a81e47aa5897f9d)
        };
        else return section;
    });
};
const $7266d6a19968ddba$export$c1d55b5930c7b9a8 = ({ space: space, webItemSections: webItemSections, isSpaceAdmin: isSpaceAdmin })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { canManageUsers: canManageUsers } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? false : undefined
    });
    const canSeeAnalytics = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? canManageUsers : isSpaceAdmin;
    // i18n messages
    const i18n = (0, $aXWIB.defineMessages)({
        analyticsPermissions: {
            id: "space-settings.analytics-permissions.label",
            defaultMessage: "Analytics permissions"
        }
    });
    // overrides the plugin analytics permissions link with native link if it is enabled
    if (webItemSections) return webItemSections.map((section)=>{
        if (section && section.id === $7266d6a19968ddba$export$d4bd26a59527e878) {
            // Filter out analytics item when user cannot see it (experiment+RBAC: MANAGE_USERS; else space admin)
            const itemsWithoutAnalyticsIfHidden = canSeeAnalytics ? section.items : section.items.filter((item)=>item?.completeKey !== $7266d6a19968ddba$export$d6ee871af16ff724);
            // Check if the analytics item already exists
            const hasAnalyticsItem = itemsWithoutAnalyticsIfHidden.some((item)=>item && item.completeKey === $7266d6a19968ddba$export$d6ee871af16ff724);
            // Map over the items and update the URL if the analytics item exists
            const updatedItems = itemsWithoutAnalyticsIfHidden.map((item)=>{
                if (space && item && item.completeKey === $7266d6a19968ddba$export$d6ee871af16ff724) {
                    const nativePermissionsURL = (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
                        spaceKey: space.alias ? space.alias : space.key,
                        tab: 'analytics'
                    });
                    return {
                        ...item,
                        label: formatMessage(i18n.analyticsPermissions),
                        url: nativePermissionsURL
                    };
                }
                return item;
            });
            // If the analytics item does not exist, inject it (and MANAGE_USERS when permissions_rbac_dependencies_callsites is on)
            // Note the id and completeKey is just copied from the original plugin web item
            if (!hasAnalyticsItem && space && edition === (0, $euL71.ConfluenceEdition).PREMIUM && canSeeAnalytics && !isCompanyHub) {
                const nativePermissionsURL = (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
                    spaceKey: space.alias ? space.alias : space.key,
                    tab: 'analytics'
                });
                const object = {
                    id: 'com.addonengine.analytics__analytics-permissions-space-tools-tab',
                    completeKey: $7266d6a19968ddba$export$d6ee871af16ff724,
                    label: formatMessage(i18n.analyticsPermissions),
                    url: nativePermissionsURL,
                    icon: null
                };
                updatedItems.push(object);
            }
            return {
                ...section,
                items: updatedItems
            };
        }
        return section;
    });
    return webItemSections;
};
const $7266d6a19968ddba$export$3f753b0635883b6c = ({ space: space, webItemSections: webItemSections })=>{
    if (!(0, $9wGTI.fg)('confluence-fe-space-settings-enable-afm-pdf')) return webItemSections;
    if (!space?.alias && !space?.key) return webItemSections;
    const ExportUrl = (0, $1NBp8.SPACE_SETTINGS_EXPORT).toUrl({
        spaceKey: space.alias || space.key
    });
    return webItemSections?.map((section)=>{
        if (section?.id === $7266d6a19968ddba$export$30163b4bd8cf5751) return {
            ...section,
            items: section.items.map((item)=>item?.completeKey === (0, $k6w4J.KeysOfWebItemsWithExtraUrls).EXPORT_SPACE_WEBITEM_COMPLETE_KEY ? {
                    ...item,
                    url: ExportUrl
                } : item)
        };
        return section;
    });
};
const $7266d6a19968ddba$var$AVATARS_AND_STATUS_COMPLETEKEY = 'confluence.sections.space.tools.v2:avatars-and-status';
const $7266d6a19968ddba$var$i18nStatusAndApprovals = (0, $aXWIB.defineMessages)({
    statusAndApprovalsLabel: {
        id: "space-settings.status-and-approvals.label",
        defaultMessage: "Status and approvals"
    },
    avatarsLabel: {
        id: "space-settings.avatars.label",
        defaultMessage: "Avatars"
    }
});
const $7266d6a19968ddba$var$useStatusAndApprovalsWebItem = ({ space: space, webItemSections: webItemSections })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) || !space?.alias && !space?.key) return webItemSections;
    const spaceKey = space.alias || space.key;
    const statusAndApprovalsUrl = (0, $1NBp8.SPACE_SETTINGS_STATUS_AND_APPROVALS).toUrl({
        spaceKey: spaceKey
    });
    const avatarsUrl = (0, $1NBp8.SPACE_SETTINGS_AVATARS).toUrl({
        spaceKey: spaceKey
    });
    return webItemSections?.map((section)=>{
        if (section?.id !== $7266d6a19968ddba$export$30163b4bd8cf5751) return section;
        const hasAvatarsAndStatusItem = section.items.some((item)=>item?.completeKey === $7266d6a19968ddba$var$AVATARS_AND_STATUS_COMPLETEKEY);
        if (!hasAvatarsAndStatusItem) return section;
        const updatedItems = section.items.flatMap((item)=>{
            if (item?.completeKey !== $7266d6a19968ddba$var$AVATARS_AND_STATUS_COMPLETEKEY) return [
                item
            ];
            // Replace "Avatars and status" with "Status and approvals" and inject new "Avatars" item
            return [
                {
                    ...item,
                    label: formatMessage($7266d6a19968ddba$var$i18nStatusAndApprovals.statusAndApprovalsLabel),
                    url: statusAndApprovalsUrl
                },
                {
                    id: 'space-settings-avatars',
                    completeKey: 'confluence.sections.space.tools.v2:avatars',
                    label: formatMessage($7266d6a19968ddba$var$i18nStatusAndApprovals.avatarsLabel),
                    url: avatarsUrl,
                    icon: null
                }
            ];
        });
        return {
            ...section,
            items: updatedItems
        };
    });
};
const $7266d6a19968ddba$export$c79ef33dba3f2dca = ({ webItemSections: webItemSections })=>{
    if ((0, $6mKj3.expVal)('confluence_tinymce_deprecation_phase', 'value', 0) <= 1) return webItemSections;
    return webItemSections?.filter((0, $2C7m5.isNonNullable)).map((section)=>({
            ...section,
            items: section.items.filter((item)=>item?.completeKey !== 'confluence.sections.space.tools.v2:editor-conversion')
        }));
};
const $7266d6a19968ddba$export$2d0405c2ed24f4db = (data)=>{
    const space = data?.space;
    const isSpaceAdmin = data?.space?.currentUser?.isAdmin;
    const injectors = [
        $7266d6a19968ddba$var$useManageSpaceWebItemSection,
        $7266d6a19968ddba$var$useManageContentWebItemSection,
        (0, $8c11d5474368d0f0$export$98e0bba00ee80f6f),
        (0, $4eea9b9f092ef5ea$export$7c1851345f26e096),
        (0, $06d067ca6d2195d0$export$3eafcac383b16a02),
        (0, $2de1cae442b950e2$export$771e5d446ad72896),
        (0, $6421ce7c16285904$export$8f5961b682362946),
        $7266d6a19968ddba$export$c1d55b5930c7b9a8,
        $7266d6a19968ddba$export$3f753b0635883b6c,
        $7266d6a19968ddba$export$c79ef33dba3f2dca,
        $7266d6a19968ddba$var$useStatusAndApprovalsWebItem
    ];
    const initialSections = data?.webItemSections ?? undefined;
    return injectors.reduce((webItemSections, injector)=>injector({
            space: space,
            webItemSections: webItemSections,
            isSpaceAdmin: isSpaceAdmin ?? false
        }), initialSections);
};
module.exports["AUTOMATION_WEBITEM_KEY"] = $7266d6a19968ddba$export$b18ac9e6fbc862e3;
module.exports["AUTOMATION_WEBITEM_SECTION_ID_V1"] = $7266d6a19968ddba$export$26aa0451233f62c3;
module.exports["AUTOMATION_WEBITEM_SECTION_ID_V2"] = $7266d6a19968ddba$export$f4c63696b5148d5d;
module.exports["useSpaceSettingsWebItemSectionsFromQuery"] = $7266d6a19968ddba$export$2d0405c2ed24f4db;

});

parcelRegister("lxdLN", function(module, exports) {
var $2d5342d9ae424e34$export$d63ce7c00a3e3a81 = /*#__PURE__*/ function(ExportPolicyEnum) {
    ExportPolicyEnum["ENABLED"] = "ENABLED";
    ExportPolicyEnum["DISABLED"] = "DISABLED";
    ExportPolicyEnum["ERROR"] = "ERROR";
    ExportPolicyEnum["LOADING"] = "LOADING";
    return ExportPolicyEnum;
}({});
module.exports["ExportPolicyEnum"] = $2d5342d9ae424e34$export$d63ce7c00a3e3a81;

});

parcelRegister("9svYf", function(module, exports) {
/**
 * @generated SignedSource<<fee57c4f4693f3ef88b7c7fffb9c478c>>
 * @relayHash 716878928b1dcc5b1b422d1897047dd6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3dba8dc7e37fb2efbf43052de7414ebb5cbe4deca9e8c490e28971ce2f1fbfa
const $1da0456768a786be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "spaceId"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "isExportEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useExportEnabledStateIsExportEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useExportEnabledStateIsExportEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "716878928b1dcc5b1b422d1897047dd6",
            "id": "b3dba8dc7e37fb2efbf43052de7414ebb5cbe4deca9e8c490e28971ce2f1fbfa",
            "metadata": {},
            "name": "useExportEnabledStateIsExportEnabledQuery",
            "operationKind": "query",
            "text": "query useExportEnabledStateIsExportEnabledQuery($spaceId:ID!){space(id:$spaceId){id,isExportEnabled}}"
        }
    };
}();
$1da0456768a786be$var$node.hash = "7dc5ad2fbf18d8407f8dbf38fc1c5d14";
var $1da0456768a786be$export$2e2bcd8739ae039 = $1da0456768a786be$var$node;



var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");


var $lxdLN = parcelRequire("lxdLN");

const $de074c62ce45d5f5$export$57171ebbe2569872 = (spaceId)=>{
    const [exportPolicyState, setExportPolicyState] = (0, $42omo.useState)((0, $lxdLN.ExportPolicyEnum).LOADING);
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const skipQuery = !spaceId || Boolean(undefined); // IsExportEnabledQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $1da0456768a786be$export$2e2bcd8739ae039), {
        variables: {
            spaceId: spaceId || ''
        },
        skip: skipQuery,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        __callerPackage__: "@confluence/export-space"
    });
    (0, $42omo.useMemo)(()=>{
        const isExportEnabled = data?.space?.isExportEnabled;
        if (error) {
            if (error?.message.includes('DataExportPolicyCheckException')) (0, $7Sm4c.markErrorAsHandled)(error);
            setExportPolicyState((0, $lxdLN.ExportPolicyEnum).ERROR);
        } else if (loading) setExportPolicyState((0, $lxdLN.ExportPolicyEnum).LOADING);
        else if (!!data && isExportEnabled) setExportPolicyState((0, $lxdLN.ExportPolicyEnum).ENABLED);
        else if (!!data && !isExportEnabled) setExportPolicyState((0, $lxdLN.ExportPolicyEnum).DISABLED);
    }, [
        data,
        loading,
        error
    ]);
    return {
        exportPolicyState: exportPolicyState,
        error: error
    };
};
module.exports["useExportEnabledState"] = $de074c62ce45d5f5$export$57171ebbe2569872;

});

parcelRegister("1OQlm", function(module, exports) {
const $b3217fa901c7995d$export$bf98aa5bf4a9468c = (extension)=>extension?.dataClassificationPolicyDecision?.status === 'BLOCKED';
module.exports["isBlockedByAppAccessRule"] = $b3217fa901c7995d$export$bf98aa5bf4a9468c;

});

parcelRegister("eXaFc", function(module, exports) {
/* ForgeAppsLoader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $ebrpi = parcelRequire("ebrpi");


var $9hlns = parcelRequire("9hlns");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");

const $e420fd3c7de727cc$export$f7109619a5e9e0d6 = 'forgeAppSpaceSettingsV2Navigation'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e420fd3c7de727cc$var$StyledErrorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1wpzesu3 _n3tdv77o _4t3igktf",
            __cmplp.className
        ])
    });
});
const $e420fd3c7de727cc$var$StyledErrorMessage = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _syazazsu",
            __cmplp.className
        ])
    });
});
const $e420fd3c7de727cc$var$i18n = (0, $aXWIB.defineMessages)({
    errorLoadingApps: {
        id: "space-settings.forge-apps-tabs.error-loading",
        defaultMessage: "Some apps may have failed to load"
    }
});
const $e420fd3c7de727cc$export$c2c47ece1497654a = ({ showLoadingErrorStates: showLoadingErrorStates = true, onLoadForgeApps: onLoadForgeApps, onError: onError })=>{
    const LazyLoaderForgeUIExtensions = (0, $42omo.useMemo)(()=>// display spinner while Forge extensions are lazy loading
        (0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>showLoadingErrorStates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                size: "small"
            }) : null), [
        showLoadingErrorStates
    ]);
    const render = (0, $42omo.useCallback)((apps, loading, error)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e420fd3c7de727cc$var$ForgeAppsLoaderComponent, {
            apps: apps,
            loading: loading,
            error: error,
            onLoadForgeApps: onLoadForgeApps,
            onError: onError,
            showLoadingErrorStates: showLoadingErrorStates
        });
    }, [
        onLoadForgeApps,
        onError,
        showLoadingErrorStates
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoaderForgeUIExtensions, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_SPACE_SETTINGS),
        render: render,
        returnBlockedExtensions: true
    });
};
const $e420fd3c7de727cc$var$ForgeAppsLoaderComponent = ({ apps: apps, loading: loading, error: error, onError: onError, onLoadForgeApps: onLoadForgeApps, showLoadingErrorStates: showLoadingErrorStates })=>{
    const [allApps, setAllApps] = (0, $42omo.useState)([]);
    const [errorInState, setErrorInState] = (0, $42omo.useState)(undefined);
    (0, $42omo.useEffect)(()=>{
        const a = apps.map((app)=>app.id);
        const b = allApps.map((app)=>app.id); // Set the apps into state, but only if the data is new.
        // The length check is quicker so execute first; but if lengths are equal, check actual app IDs.
        if (apps.length !== allApps.length || // Only need to check one way if array length is the same (assume there are no duplicate IDs)
        !a.every((el)=>b.includes(el))) {
            setAllApps(apps);
            onLoadForgeApps && onLoadForgeApps(apps);
        }
    }, [
        apps,
        allApps,
        onLoadForgeApps
    ]);
    (0, $42omo.useEffect)(()=>{
        if (error && error.message !== errorInState?.message) {
            setErrorInState(error);
            onError && onError(error);
        }
    }, [
        error,
        onError,
        errorInState
    ]);
    if (!showLoadingErrorStates) return null;
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small",
        testId: "forge-apps-tabs-loading-spinner"
    });
     // this component handles loading/error states, but the actual tabs for the apps
    // themselves are rendered by a parent component due to the need to control
    // them alongside non-Forge tabs
    return error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e420fd3c7de727cc$export$fd61fd7f99692bc3, {
        error: error
    }) : null;
};
const $e420fd3c7de727cc$export$fd61fd7f99692bc3 = ({ error: error })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e420fd3c7de727cc$var$StyledErrorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e420fd3c7de727cc$var$StyledErrorMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e420fd3c7de727cc$var$i18n.errorLoadingApps))));
};
module.exports["ANALYTICS_SOURCE"] = $e420fd3c7de727cc$export$f7109619a5e9e0d6;
module.exports["ForgeAppsLoader"] = $e420fd3c7de727cc$export$c2c47ece1497654a;
module.exports["ForgeAppLinksLoadingError"] = $e420fd3c7de727cc$export$fd61fd7f99692bc3;

});

parcelRegister("2EzwX", function(module, exports) {
/**
 * @generated SignedSource<<f8cdfef0d4b17876e9f67f85f9cf8c6e>>
 * @relayHash d4ad6fff23b099908859f608b2b9ef90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e689b0ef93e9cd90885cbd02f832f5f45dd27db789519ab338357d20667d96ef
const $cd6ad6cdf673292d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = [
        {
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "location",
                    "value": "system.space.tools"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceSettingsFilterBarQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceSettingsFilterBarQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "d4ad6fff23b099908859f608b2b9ef90",
            "id": "e689b0ef93e9cd90885cbd02f832f5f45dd27db789519ab338357d20667d96ef",
            "metadata": {},
            "name": "SpaceSettingsFilterBarQuery",
            "operationKind": "query",
            "text": "query SpaceSettingsFilterBarQuery($spaceKey:String){webItemSections(location:\"system.space.tools\",key:$spaceKey){id,label,cacheKey,items{id,completeKey,label,url,icon{path}}},space(key:$spaceKey){alias,id,key,currentUser{isAdmin}}}"
        }
    };
}();
$cd6ad6cdf673292d$var$node.hash = "bec7eccfcd875ecb2def1e08a955cdf3";
var $cd6ad6cdf673292d$export$2e2bcd8739ae039 = $cd6ad6cdf673292d$var$node;



var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $jSnXV = parcelRequire("jSnXV");


var $eUiqt = parcelRequire("eUiqt");


var $inPa6 = parcelRequire("inPa6");


var $jluld = parcelRequire("jluld");


var $ebrpi = parcelRequire("ebrpi");


var $6T8v4 = parcelRequire("6T8v4");


var $3hOY6 = parcelRequire("3hOY6");


var $u9agA = parcelRequire("u9agA");


var $b3j2Y = parcelRequire("b3j2Y");


var $8a9Dm = parcelRequire("8a9Dm");


var $9fBoq = parcelRequire("9fBoq");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $lJes8 = parcelRequire("lJes8");


var $k6w4J = parcelRequire("k6w4J");


var $hJKdQ = parcelRequire("hJKdQ");


var $2C7m5 = parcelRequire("2C7m5");


var $13KEb = parcelRequire("13KEb");

var $e375d16b7c7d13ff$exports = {};
$e375d16b7c7d13ff$exports = new URL("searchNoResults.7be90ed3.svg", import.meta.url).toString();



var $eXaFc = parcelRequire("eXaFc");








var $dPJCf = parcelRequire("dPJCf");


var $c6lYi = parcelRequire("c6lYi");

const $8ef40f50f7cc42aa$export$50acb5a9c3d154e1 = ()=>{
    const isSpacePermissionsPageArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name;
        }
    };
    const isSpacePermissionsPage = (0, $dPJCf.useRouteName)(isSpacePermissionsPageArgs);
    if (!isSpacePermissionsPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c6lYi.FeedbackCollectorButton), {
        source: "Space Access"
    });
};



var $lvOsp = parcelRequire("lvOsp");

const $6a7d04310ebd2218$var$SpaceSettingsFilterBarQuery = (0, $cd6ad6cdf673292d$export$2e2bcd8739ae039);
const $6a7d04310ebd2218$var$ANALYTICS_ACTION_SUBJECT = 'spaceSettingsFilterBar'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a7d04310ebd2218$var$FilterBarContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsbr0r7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a7d04310ebd2218$var$OptionInMenu = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt418iy",
            __cmplp.className
        ])
    });
});
const $6a7d04310ebd2218$var$customSelectStyles = {
    group: (styles)=>({
            ...styles,
            paddingTop: 0,
            paddingBottom: 0
        }),
    control: (styles, state)=>({
            ...styles,
            flexDirection: 'row-reverse',
            // B100 corresponds with primary75 theme color from react-select
            // This is the standard blue border color used by focused elements
            borderColor: state.isFocused ? "var(--ds-border-focused, #4688EC)" : "var(--ds-border, #0B120E24)",
            background: "var(--ds-background-input, #FFFFFF)"
        }),
    // boost z index menu over some legacy SSR page HTML elements
    menu: (styles)=>({
            ...styles,
            zIndex: 9
        })
};
const $6a7d04310ebd2218$var$i18n = (0, $aXWIB.defineMessages)({
    searchPlaceholderText: {
        id: "space-settings.navigation.filter-bar.placeholder-text",
        defaultMessage: "Jump to setting..."
    },
    noOptionsMessage: {
        id: "space-settings.navigation.filter-bar.empty-options",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We couldn't find anything matching your search."
    },
    errorLoadingResults: {
        id: "space-settings.navigation.filter-bar.error-loading",
        defaultMessage: "Some links failed to load"
    }
});
const $6a7d04310ebd2218$export$8175bc16c0b255f9 = ({ includeForgeApps: includeForgeApps = true, spaceKey: spaceKey, spaceAlias: spaceAlias, source: source, forgeAppId: forgeAppId, forgeEnvId: forgeEnvId, forgeRoutePath: forgeRoutePath })=>{
    // Forge apps will be loaded by a child component and set into state locally.
    const [forgeApps, setForgeApps] = (0, $42omo.useState)([]);
    const [startLoading, setStartLoading] = (0, $42omo.useState)(false);
    const [forgeLoadError, setForgeLoadError] = (0, $42omo.useState)();
    const { location: location, matchRoute: matchRoute, push: push } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [queryForWebItems, { data: data, loading: loading, error: webItemQueryError }] = (0, $lvOsp.useLazyQueryInterop)($6a7d04310ebd2218$var$SpaceSettingsFilterBarQuery, {
        variables: {
            spaceKey: spaceKey
        },
        errorPolicy: 'all',
        __callerPackage__: "@confluence/space-settings"
    });
    const handleMenuOpen = ()=>{
        // load options if we do not already have data
        if (!loading && !data) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'search',
                    actionSubjectId: $6a7d04310ebd2218$var$ANALYTICS_ACTION_SUBJECT,
                    source: source
                }
            }).fire();
            queryForWebItems();
            setStartLoading(true);
        }
    };
    const onLoadForgeError = (forgeError)=>{
        setForgeLoadError(forgeError);
    };
    const handleSelectLink = (item)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: $6a7d04310ebd2218$var$ANALYTICS_ACTION_SUBJECT,
                source: source,
                attributes: {
                    linkId: item?.value
                }
            }
        }).fire();
        item?.data.href && push(item.data.href);
    };
    const createForgeAppOptions = (parentWebItemSection)=>forgeApps.length ? forgeApps.filter((0, $2C7m5.isNonNullable)).map((forgeApp)=>{
            const appId = (0, $8a9Dm.getAppId)(forgeApp) ?? '';
            return {
                label: (0, $9fBoq.extensionTitle)(forgeApp),
                value: appId,
                data: {
                    href: (0, $1NBp8.SPACE_SETTINGS_FORGE_APPS).toUrl({
                        spaceKey: spaceAlias || spaceKey,
                        appId: appId,
                        envId: forgeApp.environmentId,
                        forgeManifestRoute: forgeApp.properties?.route
                    }),
                    forgeApp: forgeApp,
                    parentLabel: parentWebItemSection.label
                }
            };
        }) : [];
    const webItemSections = (0, $13KEb.useSpaceSettingsWebItemSectionsFromQuery)(data);
    const allOptions = webItemSections?.filter((0, $2C7m5.isNonNullable)).map((webItemSection)=>({
            label: webItemSection.label ?? undefined,
            id: webItemSection.id,
            options: webItemSection.items.filter((0, $2C7m5.isNonNullable)).map((item)=>({
                    label: item.label,
                    value: item.completeKey,
                    data: {
                        href: item.url,
                        parentLabel: webItemSection.label
                    }
                })) // If we are in the correct top-level webItemSections, we can add on Forge apps
            // to the inner `options` array that we are currently creating
            .concat(webItemSection.id === (0, $k6w4J.FORGE_SPACE_SETTINGS_NAVIGATION_PARENT_WEBITEM) ? createForgeAppOptions(webItemSection) : [])
        })) ?? [];
    const { innerNavigationWebItem: innerNavigationWebItem } = (0, $k6w4J.useSelectedNavigationWebItems)({
        matchRoute: matchRoute,
        location: location,
        webItemSections: webItemSections
    });
    const formatOptionLabel = ({ label: label }, { inputValue: inputValue })=>{
        // bold text in the option label that matches the search string, if any
        const optionTextWithMatchesHighlighted = inputValue ? label.replace(new RegExp(inputValue, 'gi'), (highlighted)=>`<b>${highlighted}</b>`) : label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a7d04310ebd2218$var$OptionInMenu, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            dangerouslySetInnerHTML: {
                __html: optionTextWithMatchesHighlighted
            }
        }));
    };
    const filterOption = ({ label: label, value: value, data: optionData }, inputValue)=>{
        // Filter out the option for the space settings page we are currently on, if any.
        // If we are on a Forge app page we match the option through forge props passed through from navigation.
        // Otherwise, we compare against innerNavigationWebItem which matches the selected page by URL.
        const optionIsCurrentPage = optionData.data?.forgeApp ? (0, $k6w4J.isForgeAppMatchingRoute)(optionData.data.forgeApp, forgeAppId, forgeEnvId, forgeRoutePath) : innerNavigationWebItem?.completeKey === value;
        return !optionIsCurrentPage && // Filter options by search text (inputValue) - does it match either the option label or its parent?
        (label?.search(new RegExp((0, (/*@__PURE__*/$parcel$interopDefault($eUiqt)))(inputValue), 'i')) > -1 || optionData.data?.parentLabel?.search(new RegExp((0, (/*@__PURE__*/$parcel$interopDefault($eUiqt)))(inputValue), 'i')) > -1);
    };
    const fireTypeEvent = (searchTerm)=>{
        if (searchTerm?.length) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'typed',
                actionSubject: 'searchTerm',
                actionSubjectId: $6a7d04310ebd2218$var$ANALYTICS_ACTION_SUBJECT,
                source: source,
                attributes: {
                    searchTermLength: searchTerm.length
                }
            }
        }).fire();
    };
    const handleType = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(fireTypeEvent, 200, {
        leading: false
    });
    const error = webItemQueryError ?? forgeLoadError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8ef40f50f7cc42aa$export$50acb5a9c3d154e1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a7d04310ebd2218$var$FilterBarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        options: allOptions,
        id: "space-settings-filter-bar",
        className: "single-select",
        classNamePrefix: "react-select",
        styles: $6a7d04310ebd2218$var$customSelectStyles,
        maxMenuHeight: 400,
        formatOptionLabel: formatOptionLabel,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6a7d04310ebd2218$var$i18n.searchPlaceholderText),
        label: "Search settings",
        isLoading: loading,
        onInputChange: handleType,
        onMenuOpen: handleMenuOpen,
        onChange: handleSelectLink,
        filterOption: filterOption,
        // space setting page. When the desired result is clicked, we redirect user to the URL of the selected
        // option. There is no reason for selected value to persist inside the component, either before
        // redirection or especially between SPA pageloads (e.g. switching between Forge app tabs), in which this
        // component will stay mounted. So "selected value" should consistently be empty.
        value: null,
        components: {
            DropdownIndicator: $6a7d04310ebd2218$var$CustomDropdownIndicator,
            NoOptionsMessage: $6a7d04310ebd2218$var$CustomNoOptionsMessage,
            GroupHeading: $6a7d04310ebd2218$var$CustomGroupHeading,
            MenuList: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a7d04310ebd2218$var$CustomMenuList, {
                    error: error,
                    ...props
                })
        }
    }), includeForgeApps && startLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eXaFc.ForgeAppsLoader), {
        onLoadForgeApps: setForgeApps,
        onError: onLoadForgeError,
        showLoadingErrorStates: false
    }) : null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null));
};
// A few custom styled components for Select
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a7d04310ebd2218$var$GroupLabel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _11q7i8nm _1e0c1txw _1bah1y6m _4cvr1h6o _19bvv47k _syazazsu",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a7d04310ebd2218$var$GroupLabelText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41h37",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a7d04310ebd2218$var$NoOptionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4xy5q _1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a7d04310ebd2218$var$NoOptionsMessage = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _syazi7uo _1bsbbv7e _y3gn1h6o _ca0q1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a7d04310ebd2218$var$StyledErrorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41e2s _1wpzesu3 _4t3igktf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a7d04310ebd2218$var$StyledErrorMessage = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8wadc _syazazsu",
            __cmplp.className
        ])
    });
});
const $6a7d04310ebd2218$var$CustomDropdownIndicator = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        spacing: "spacious",
        label: ""
    }));
const $6a7d04310ebd2218$var$CustomNoOptionsMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a7d04310ebd2218$var$NoOptionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e375d16b7c7d13ff$exports))),
        width: 125,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a7d04310ebd2218$var$NoOptionsMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6a7d04310ebd2218$var$i18n.noOptionsMessage))); // GroupHeading component props are typed as "any" from AkSelect
const $6a7d04310ebd2218$var$CustomGroupHeading = (props)=>{
    const webItemIdMapToIcon = (0, $hJKdQ.getWebItemIdMapToIcon)(); // custom icon per section / grouping, same as the space settings landing page
    const IconComponent = webItemIdMapToIcon[props.data.id] ?? (0, $lJes8.IntegrationsIconV2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).GroupHeading, {
        ...props,
        style: {
            margin: 0,
            padding: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a7d04310ebd2218$var$GroupLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconComponent, {
        width: "24",
        height: "24"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a7d04310ebd2218$var$GroupLabelText, null, props.data.label)));
};
const $6a7d04310ebd2218$var$CustomMenuList = ({ error: error, children: children, ...menuListComponentProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).MenuList, menuListComponentProps, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a7d04310ebd2218$var$StyledErrorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6a7d04310ebd2218$var$StyledErrorMessage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6a7d04310ebd2218$var$i18n.errorLoadingResults))) : null, children);
module.exports["SpaceSettingsFilterBar"] = $6a7d04310ebd2218$export$8175bc16c0b255f9;

});

parcelRegister("lJes8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jdPfT = parcelRequire("jdPfT");

const $da7b299f244d71f7$export$17ed21243f255edf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: "",
        spacing: "spacious"
    });
module.exports["IntegrationsIconV2"] = $da7b299f244d71f7$export$17ed21243f255edf;

});

parcelRegister("hJKdQ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $87a9ee78e692749f$export$6514915f794aa404 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        rx: "3",
        fill: "var(--ds-background-accent-gray-subtlest, #F0F1F2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.3399 9.97969C22.7512 9.42098 23.6362 9.78092 23.5408 10.4681L21.7349 23.4699H13.7322C13.1839 23.4699 12.8686 22.8463 13.1937 22.4048L22.3399 9.97969Z",
        fill: "var(--ds-icon, #292A2E)",
        fillOpacity: "0.95"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.4245 18.1148C27.9728 18.1148 28.288 18.7384 27.963 19.1799L18.8168 31.605C18.4055 32.1637 17.5205 31.8038 17.6159 31.1166L19.4217 18.1148H23.976L27.4245 18.1148Z",
        fill: "var(--ds-icon, #292A2E)",
        fillOpacity: "0.95"
    }));





var $4GKfl = parcelRequire("4GKfl");

const $f57860d8fe4fcaa4$export$d49a3d7b9eebf70b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GKfl))), {
        label: "",
        spacing: "spacious"
    });


var $lJes8 = parcelRequire("lJes8");




var $lLRaS = parcelRequire("lLRaS");

const $cdf9ab025d4ae58a$export$36eacc82fb6780b5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lLRaS))), {
        label: "",
        spacing: "spacious"
    });





var $8jHAi = parcelRequire("8jHAi");

const $61c7a97af811c20f$export$aa4d3ad89d692d30 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
        label: "",
        spacing: "spacious"
    });





var $fIcbd = parcelRequire("fIcbd");

const $78124e7714bba903$export$59861c366fa00f7c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fIcbd))), {
        label: "",
        spacing: "spacious"
    });




const $e207865cdae572df$export$d25764ff495f5696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        rx: "3",
        fill: "var(--ds-background-accent-gray-subtlest, #F0F1F2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.7229 7.85542C30.4615 7.85542 31.0602 8.45417 31.0602 9.19277V13.0241C31.0602 13.7627 30.4615 14.3614 29.7229 14.3614H10.0602C9.32164 14.3614 8.72289 13.7627 8.72289 13.0241V9.19277C8.72289 8.45417 9.32164 7.85542 10.0602 7.85542H29.7229Z",
        fill: "var(--ds-icon, #292A2E)",
        fillOpacity: "0.95"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.8664 11.0627C20.8424 10.545 20.4151 10.1327 19.8916 10.1327C19.3526 10.1327 18.9157 10.5696 18.9157 11.1086V19.0243H14.5783L14.5087 19.0249C12.5646 19.062 11 20.6496 11 22.6026V28.8917L11.0011 28.9377C11.025 29.4553 11.4523 29.8676 11.9759 29.8676C12.5149 29.8676 12.9518 29.4307 12.9518 28.8917V22.6026L12.9526 22.5499C12.9804 21.676 13.6976 20.9761 14.5783 20.9761H18.9157V28.8917L18.9167 28.9377C18.9407 29.4553 19.368 29.8676 19.8916 29.8676C20.4305 29.8676 20.8675 29.4307 20.8675 28.8917V20.9761H25.2048L25.2575 20.9769C26.1314 21.0047 26.8313 21.7219 26.8313 22.6026V28.8917L26.8324 28.9377C26.8564 29.4553 27.2836 29.8676 27.8072 29.8676C28.3462 29.8676 28.7831 29.4307 28.7831 28.8917V22.6026L28.7825 22.533C28.7454 20.5888 27.1578 19.0243 25.2048 19.0243H20.8675V11.1086L20.8664 11.0627Z",
        fill: "var(--ds-icon, #292A2E)",
        fillOpacity: "0.95"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "8.72289",
        y: "25.6386",
        width: "6.50602",
        height: "6.50603",
        rx: "1.33735",
        fill: "var(--ds-icon, #292A2E)",
        fillOpacity: "0.95"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "24.5542",
        y: "25.6386",
        width: "6.50602",
        height: "6.50603",
        rx: "1.33735",
        fill: "var(--ds-icon, #292A2E)",
        fillOpacity: "0.95"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        x: "16.6385",
        y: "25.6386",
        width: "6.50602",
        height: "6.50603",
        rx: "1.33735",
        fill: "var(--ds-icon, #292A2E)",
        fillOpacity: "0.95"
    }));





var $9Q2dU = parcelRequire("9Q2dU");

const $eac07489a1215a84$export$a1324f8ab9f9e767 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
        label: "",
        spacing: "spacious"
    });





var $28NpI = parcelRequire("28NpI");

const $28a1c85b96a873e6$export$e51387390d59ba8b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($28NpI))), {
        label: "",
        spacing: "spacious"
    });



var $13KEb = parcelRequire("13KEb");

const $62155e9654b62568$var$WEB_ITEM_ID_MAP_TO_ICON = {
    '-system.space.tools-com.metainf.confluence.plugin.pagetreeexporter.pagetree-word-exporter-plugin__cex-admin-space-tools': (0, $e207865cdae572df$export$d25764ff495f5696),
    '-system.space.tools-com.refinedwiki.confluence.cloud.refinedtheme__rw-theming-section': (0, $28a1c85b96a873e6$export$e51387390d59ba8b),
    '-system.space.tools-contenttools': (0, $61c7a97af811c20f$export$aa4d3ad89d692d30),
    '-system.space.tools-integrations': (0, $lJes8.IntegrationsIconV2),
    '-system.space.tools-lookandfeel': (0, $cdf9ab025d4ae58a$export$36eacc82fb6780b5),
    '-system.space.tools-overview': (0, $78124e7714bba903$export$59861c366fa00f7c),
    '-system.space.tools-permissions': (0, $eac07489a1215a84$export$a1324f8ab9f9e767),
    '-system.space.tools-data-protection': (0, $f57860d8fe4fcaa4$export$d49a3d7b9eebf70b),
    [(0, $13KEb.AUTOMATION_WEBITEM_SECTION_ID_V1)]: (0, $87a9ee78e692749f$export$6514915f794aa404),
    [(0, $13KEb.AUTOMATION_WEBITEM_SECTION_ID_V2)]: (0, $87a9ee78e692749f$export$6514915f794aa404)
};
const $62155e9654b62568$export$43d24f87438da3e4 = ()=>$62155e9654b62568$var$WEB_ITEM_ID_MAP_TO_ICON;
module.exports["getWebItemIdMapToIcon"] = $62155e9654b62568$export$43d24f87438da3e4;

});

parcelRegister("c6lYi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $7yOcR = parcelRequire("7yOcR");


var $7aRa9 = parcelRequire("7aRa9");


var $iquRY = parcelRequire("iquRY");








var $biiXa = parcelRequire("biiXa");


var $bQm3c = parcelRequire("bQm3c");




const $fe7fcc34e2e5b785$var$i18n = (0, $aXWIB.defineMessages)({
    feedbackTitle: {
        id: "space-roles.feedback-collector.title",
        defaultMessage: "Give feedback"
    },
    feedbackTitleDetails: {
        id: "space-roles.feedback-collector.title-details",
        defaultMessage: "How satisfied or dissatisfied are you overall with your experience using roles to manage access in Confluence?"
    }
});
const $fe7fcc34e2e5b785$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $fe7fcc34e2e5b785$var$ENTRYPOINT_ID = 'ba8149f4-b7d4-4f55-9e72-683a444d3b27';
const $fe7fcc34e2e5b785$export$91e87cfcc7a6c95d = ({ isOpen: isOpen, onClose: onClose, onSubmit: onSubmit, source: source })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const { displayName: displayName, userId: userId, cloudId: cloudId, edition: edition, environment: environment } = (0, $bQm3c.useSessionData)();
    const { spaceRoleMode: spaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const getFeedbackMetadata = ()=>{
        const feedbackMetadata = {
            userId: userId,
            cloudId: cloudId,
            edition: edition,
            environment: environment,
            source: source,
            spaceRoleMode: spaceRoleMode
        };
        return JSON.stringify(feedbackMetadata, null, 2);
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        onClose: onClose,
        onSubmit: onSubmit,
        entrypointId: $fe7fcc34e2e5b785$var$ENTRYPOINT_ID,
        locale: locale,
        name: displayName ?? '',
        atlassianAccountId: userId ?? undefined,
        showTypeField: false,
        feedbackTitle: formatMessage($fe7fcc34e2e5b785$var$i18n.feedbackTitle),
        feedbackTitleDetails: formatMessage($fe7fcc34e2e5b785$var$i18n.feedbackTitleDetails),
        additionalFields: [
            {
                id: $fe7fcc34e2e5b785$var$FEEDBACK_CONTEXT_ID,
                value: getFeedbackMetadata()
            }
        ]
    });
};


const $fa5a2619efb2e23a$var$i18n = (0, $aXWIB.defineMessages)({
    buttonText: {
        id: "space-roles.feedback-collector.button-text",
        defaultMessage: "Give feedback"
    },
    flagTitle: {
        id: "space-roles.feedback-collector.flag-title",
        defaultMessage: "Feedback submitted, thank you!"
    }
});
const $fa5a2619efb2e23a$var$FeedbackCollectorButtonComponent = ({ flags: flags, source: source, appearance: appearance = 'default' })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    return isRbacEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))),
        appearance: appearance,
        onClick: ()=>setIsOpen(true)
    }, formatMessage($fa5a2619efb2e23a$var$i18n.buttonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe7fcc34e2e5b785$export$91e87cfcc7a6c95d), {
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        onSubmit: ()=>{
            flags.showSuccessFlag({
                title: formatMessage($fa5a2619efb2e23a$var$i18n.flagTitle),
                isAutoDismiss: true
            });
        },
        source: source
    })) : null;
};
const $fa5a2619efb2e23a$export$b39479f42d974760 = (0, $7aRa9.withFlags)($fa5a2619efb2e23a$var$FeedbackCollectorButtonComponent);
module.exports["FeedbackCollectorButton"] = $fa5a2619efb2e23a$export$b39479f42d974760;

});

parcelRegister("877b2", function(module, exports) {
/**
 * @generated SignedSource<<3d0a9b280b61123ac6fb7588a62d130e>>
 * @relayHash 5d92afcae44c41d812080f4c5cba9de9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4a788c66d133695225f198344d090ebb2635c6c5bc51621d02fcc1641ad3d27
const $5bb914c24b63b757$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = [
        {
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "location",
                    "value": "system.space.tools"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "5d92afcae44c41d812080f4c5cba9de9",
            "id": "f4a788c66d133695225f198344d090ebb2635c6c5bc51621d02fcc1641ad3d27",
            "metadata": {},
            "name": "useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery",
            "operationKind": "query",
            "text": "query useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery($spaceKey:String){webItemSections(location:\"system.space.tools\",key:$spaceKey){id,label,cacheKey,items{id,completeKey,label,url,icon{path}}},space(key:$spaceKey){alias,id,key,currentUser{isAdmin}}}"
        }
    };
}();
$5bb914c24b63b757$var$node.hash = "ac644bf197ef5f2ffa2aff7f09be22b4";
var $5bb914c24b63b757$export$2e2bcd8739ae039 = $5bb914c24b63b757$var$node;



var $13KEb = parcelRequire("13KEb");


var $jMyy4 = parcelRequire("jMyy4");

const $e02e54f513256b6a$var$useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery = (0, $5bb914c24b63b757$export$2e2bcd8739ae039);
const $e02e54f513256b6a$export$305c470a339590b2 = ({ spaceAlias: spaceAlias })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($e02e54f513256b6a$var$useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery, {
        variables: {
            spaceKey: spaceAlias
        },
        __callerPackage__: "@confluence/space-settings"
    });
    const webItemSections = (0, $13KEb.useSpaceSettingsWebItemSectionsFromQuery)(data);
    return {
        loading: loading,
        error: error,
        webItemSections: !loading && !error ? webItemSections : undefined
    };
};
module.exports["useSpaceSettingsWebItemSections"] = $e02e54f513256b6a$export$305c470a339590b2;

});

parcelRegister("keG7U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ecnYn = parcelRequire("ecnYn");


var $6f0Oj = parcelRequire("6f0Oj");

const $ee7d6d313fe842a2$var$SpaceSettingsPageContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    height: '100%',
    paddingBlock: 'space.600',
    paddingInline: 'space.800'
});
const $ee7d6d313fe842a2$export$38a2669962af3d55 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $ee7d6d313fe842a2$var$SpaceSettingsPageContainerStyles,
        testId: testId
    }, children);
module.exports["SpaceSettingsPageContainer"] = $ee7d6d313fe842a2$export$38a2669962af3d55;

});


$parcel$global.rlb("IOlTS")
//# sourceMappingURL=SpaceSettingsNavigationPortal.c4c7daf8.js.map
